import React, { useState, useEffect, useRef } from "react";
import { Download } from "lucide-react";
import { getSystemConfig } from "../services/systemConfigService";
import QuoteProgressService from "../services/quoteProgressService";
import { useAuth } from "../context/AuthContext";

const RentalAgreementForm = ({ selectedConnectionId }) => {
  const { currentUser } = useAuth();
  const [showMainForm, setShowMainForm] = useState(false);
  const [rentalData, setRentalData] = useState(null);
  const [isPdfMode, setIsPdfMode] = useState(false);
  const pdfRef = useRef();
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [isGeneratingAdobePDF, setIsGeneratingAdobePDF] = useState(false);
  const token = localStorage.getItem("authToken");

  const [status, setStatus] = useState(null);
  const [reminderSent, setReminderSent] = useState(false);
  const [agreementId, setAgreementId] = useState(null);
  const [contractSigned, setContractSigned] = useState(false);

  const [formData, setFormData] = useState({
    companyName: "",
    agreementNumber: "",
    customerNumber: "",
    bank_postcode: "",
    fincompanyName: "",
    finPostcode: "",
    finAddress: "",
    managerName: "",
    customerName: "",
    coRegNo: "",
    tradingAs: "",
    address: "",
    postcode: "",
    contactName: "",
    telephone: "",
    email: "",
    fullAddress: "",
    regPostcode: "",
    locationOfProducts: "",
    locationPostcode: "",
    proprietorName: "",
    privateAddress: "",
    privatePostcode: "",
    homeTelNo: "",
    dateOfBirth: "",
    supplierName: "FIBRE TELECOMS (UK) LTD",
    salesperson: "",
    initialRental: "86.27",
    followingRentals: "86.27",
    minimumPeriod: "EIGHTY FOUR",
    rentalFrequency: "Month",
    maintenanceCharge: "",
    settlementName: "",
    settlementAmount: "",
    signature: "",
    position: "",
    date: "04/07/2025",
    directorEmail: "",
    bankName: "",
    accountHolder: "",
    sortCode: ["", "", "", "", "", ""],
    accountNumber: ["", "", "", "", "", "", "", ""],
    serviceUserNumber: "",
    reference: "",
    productsDetails: "",
    building: "",
    hirer: "",
    owner: "",
    refNumber: "",
    mainTelNo: "",
    companyAddress: "",
    companyPostcode: "",
    personalName: "",
    personalPostcode: "",
    scheduleReference: "",
    installation_address:"",
   
    regulation_status: "",
   personalName: "",        // ← from partners[0].name
    privateAddress: "",      // ← from partners[0].private_address  
    personalPostcode: "",    // ← from partners[0].postcode
    dateOfBirth: "",         // ← from partners[0].dob
    homeTelNo: "", 
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [leaseCalculatorData, setLeaseCalculatorData] = useState({
    actualLeasePayment: 0,
    actualProfit: 0,
    adjustedRental: 0,
    currentCallCharges: 0,
    current_lease_rental: 0,
    current_maintenance: 0,
    current_mobile_charges: 0,
    current_service_charges: 0,
    current_total_cost: 0,
    discountLoad: 0,
    estimatedCallCharges: 0,
    estimated_mobile_charges: 0,
    leased_line: 0,
    networkPayment: 0,
    networkSettlementContribution: 0,
    new_service_charges: 0,
    other_charges: 0,
    paymentProfile: "",
    salesRepCommission: 0,
  });
  const [linesFoc, setLinesFoc] = useState({
    hostedLifetimeLicensesFocQty: 0,
    new4g5gBroadbandFocQty: 0,
    fttpSogeaBroadbandFocQty: 0,
    starlinkBroadbandFocQty: 0,
    leasedLinesFocQty: 0,
  });

  const [hardwareItems, setHardwareItems] = useState([
    { id: 2, name: "Mobile App", quantity: 0, category: "Software", icon: "/images/mobileapp.jpg" },
    { id: 3, name: "Mobile App Addon", quantity: 0, category: "Software", icon: "📱" },
    { id: 4, name: "T54W", quantity: 0, category: "Phone", icon: "/images/t54w.png" },
    { id: 5, name: "T57W", quantity: 0, category: "Phone", icon: "/images/t57w.jpg" },
    { id: 6, name: "T58W", quantity: 0, category: "Phone", icon: "/images/t58w.jpg" },
    { id: 7, name: "YEALINK T85", quantity: 0, category: "Phone", icon: "/images/yealinkt85.jpg" },
    { id: 8, name: "YEALINK T87", quantity: 0, category: "Phone", icon: "/images/T87W.jpg" },
    { id: 9, name: "YEALINK T88", quantity: 0, category: "Phone", icon: "/images/Yealink_new.jpg" },
    { id: 10, name: "Grandstream 3470", quantity: 0, category: "Phone", icon: "/images/Grandstream_3470.jpg" },
    { id: 11, name: "Grandstream 3480", quantity: 0, category: "Phone", icon: "/images/3480.jpg" },
    { id: 12, name: "Cisco 9871", quantity: 0, category: "Phone", icon: "/images/CISCO.jpeg" },
    { id: 13, name: "Yealink W73H DECT", quantity: 0, category: "Phone", icon: "/images/ipdect.jpg" },
  ]);

  const mobileAppUsers = hardwareItems.reduce((total, item) => {
    if (item.name === "Mobile App")
      return total + (item.quantity || 0) + (item.focQuantity || 0);
    return total;
  }, 0);

  const t54w = hardwareItems.find((item) => item.name === "T54W") || { quantity: 0, focQuantity: 0 };
  const t57w = hardwareItems.find((item) => item.name === "T57W") || { quantity: 0, focQuantity: 0 };
  const t58w = hardwareItems.find((item) => item.name === "T58W") || { quantity: 0, focQuantity: 0 };
  const t85 = hardwareItems.find((item) => item.name === "YEALINK T85") || { quantity: 0, focQuantity: 0 };
  const t87 = hardwareItems.find((item) => item.name === "YEALINK T87") || { quantity: 0, focQuantity: 0 };
  const t88 = hardwareItems.find((item) => item.name === "YEALINK T88") || { quantity: 0, focQuantity: 0 };
  const grandstream3470 = hardwareItems.find((item) => item.name === "Grandstream 3470") || { quantity: 0, focQuantity: 0 };
  const grandstream3480 = hardwareItems.find((item) => item.name === "Grandstream 3480") || { quantity: 0, focQuantity: 0 };
  const cisco = hardwareItems.find((item) => item.name === "Cisco 9871") || { quantity: 0, focQuantity: 0 };
  const ipDectHandset = hardwareItems.find((item) => item.name === "Yealink W73H DECT") || { quantity: 0, focQuantity: 0 };
  const totalQty = (item) => (item.quantity || 0) + (item.focQuantity || 0);
  const [additionalHardware, setAdditionalHardware] = useState([
    { id: 24, name: "UCM IP PBX", quantity: 1, category: "UCM IP PBX", icon: "/images/ucmippbx.jpg" },
    { id: 26, name: "Draytek 2865LAC", quantity: 0, category: "Router", icon: "/images/router.png" },
    { id: 27, name: "Netgear GS108LP", quantity: 0, category: "POE", icon: "/images/poe.png" },
  ]);

  const ucmpbx = additionalHardware.find((item) => item.name === "UCM IP PBX") || { quantity: 1 };
  const wifi = additionalHardware.find((item) => item.name === "Draytek 2865LAC") || { quantity: 1 };
  const poe = additionalHardware.find((item) => item.name === "Netgear GS108LP") || { quantity: 1 };

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        if (!selectedConnectionId) return;
        const { data } = await getSystemConfig(selectedConnectionId);
       // console.log("Data",data);
        if (data) {
          setRentalData(data);
          setFormData((prev) => ({
            ...prev,
            managerName: data.md_name || prev.managerName,
            companyName: data.connection_name || prev.companyName,
            coRegNo: data.company_reg || prev.coRegNo,
            companyEmail: data.director_email || prev.companyEmail,
            telephone: data.telephone || prev.telephone,
            billingEmail: data.billing_email || prev.billingEmail,
            directorEmail: data.director_email || prev.directorEmail,
            date: data.contract_date || prev.contract_date,
            postcode: data.postcode || prev.postcode,
            salesperson: data.sales_man || prev.salesperson,
            bankName: data.bank_name || prev.bankName,
            position: data.position || prev.position,
            sortCode: data.sort_code ? String(data.sort_code).split("") : prev.sortCode,
            accountNumber: data.account_number ? String(data.account_number).split("") : prev.accountNumber,
            regPostcode: data.postcode,
            mainTelNo: data.telecom_details.find((item) => item.service_type === "SIP")?.existing_tel_no || "",
            fullAddress: [data.registered_address_line_1, data.registered_address_line_2, data.registered_address_line_3]
              .filter(Boolean).join(", "),
            installation_address: data.installation_address,
            // ── Non-limited partner data ──────────────────────────────────
            regulation_status: data.regulation_status || prev.regulation_status,
            personalName: data.partners?.[0]?.name || prev.personalName,
            privateAddress: data.partners?.[0]?.private_address || prev.privateAddress,
            personalPostcode: data.partners?.[0]?.postcode || prev.personalPostcode,
            dateOfBirth: data.partners?.[0]?.dob
            ? data.partners[0].dob.split("-").reverse().join("/")
            : prev.dateOfBirth,
              
          }));

          if (Array.isArray(data.hardwareItems)) {
            setHardwareItems((prev) =>
              prev.map((item) => {
                const backendItem = data.hardwareItems.find((h) => h.name === item.name);
                return backendItem
                  ? { ...item, quantity: backendItem.quantity, focQuantity: backendItem.focQuantity || 0 }
                  : item;
              })
            );
          }

          const backendAdditional = data.additionalHardware
            ? Array.isArray(data.additionalHardware) ? data.additionalHardware : Object.values(data.additionalHardware)
            : [];

          setAdditionalHardware((prev) =>
            prev.map((item) => {
              const backendItem = backendAdditional.find((h) => h.name === item.name);
              return backendItem
                ? { ...item, quantity: backendItem.quantity, focQuantity: backendItem.focQuantity || 0 }
                : item;
              })
          );

          if (data.leaseCalculatorData) {
            setLeaseCalculatorData({
              actualLeasePayment: data.leaseCalculatorData.actualLeasePayment || 0,
              actualProfit: data.leaseCalculatorData.actualProfit || 0,
              adjustedRental: data.leaseCalculatorData.adjustedRental || 0,
              currentCallCharges: data.leaseCalculatorData.currentCallCharges || 0,
              current_lease_rental: data.leaseCalculatorData.current_lease_rental || 0,
              current_maintenance: data.leaseCalculatorData.current_maintenance || 0,
              current_mobile_charges: data.leaseCalculatorData.current_mobile_charges || 0,
              current_service_charges: data.leaseCalculatorData.current_service_charges || 0,
              current_total_cost: data.leaseCalculatorData.current_total_cost || 0,
              discountLoad: data.leaseCalculatorData.discountLoad || 0,
              estimatedCallCharges: data.leaseCalculatorData.estimatedCallCharges || 0,
              estimated_mobile_charges: data.leaseCalculatorData.estimated_mobile_charges || 0,
              leased_line: data.leaseCalculatorData.leased_line || 0,
              networkPayment: data.leaseCalculatorData.networkPayment || 0,
              networkSettlementContribution: data.leaseCalculatorData.networkSettlementContribution || 0,
              new_service_charges: data.leaseCalculatorData.new_service_charges || 0,
              other_charges: data.leaseCalculatorData.other_charges || 0,
              paymentProfile: data.leaseCalculatorData.paymentProfile || "",
              salesRepCommission: data.leaseCalculatorData.salesRepCommission || 0,
            });
          }
          // ADD:
          if (data.linesFoc) {
            setLinesFoc(data.linesFoc);
          }

        }
      } catch (error) {
        console.error("Failed to load config:", error);
      }
    };
    fetchConfigData();
  }, [selectedConnectionId]);
  // ── Partner selection for non-limited PDF section ──
  const [selectedPartnerIndex, setSelectedPartnerIndex] = useState(0);

  const activePartner =
  formData.regulation_status === "NON LIMITED" && formData.partners?.length
    ? formData.partners[selectedPartnerIndex] ?? formData.partners[0]
    : null;   

  const sendToAdobeSign = async () => {
    if (!window.confirm(`Send to ${formData.companyEmail}?`)) return;
    setIsGeneratingAdobePDF(true);
    setIsPdfMode(true);
    setIsGeneratingPDF(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 300));
      const element = pdfRef.current;
      if (!element) throw new Error("PDF reference not found");
      const htmlContent = `<!DOCTYPE html><html><head><meta charset="UTF-8"><script src="https://cdn.tailwindcss.com"></script><style>body{font-family:Arial,sans-serif;color:#111;background:#fff;}.page-break-after{page-break-after:always;break-after:page;}*{-webkit-print-color-adjust:exact;print-color-adjust:exact;}</style></head><body>${element.innerHTML}</body></html>`;
      const tok = localStorage.getItem("authToken");
      if (!tok) throw new Error("Authentication token missing");
      const body = {
        html: htmlContent,
        signer_email: formData.companyEmail,
        signer_name: formData.managerName,
       // cc_email: "proposals@hexafinance.co.uk",
        agreement_name: `Fibre Telecoms Rental - ${formData.companyName}`,
        email_subject: `Fibre Telecoms Rental for ${formData.companyName}`,
        email_body: `Dear ${formData.managerName},\n\nPlease review and sign the attached Fibre Telecoms Rental Agreement.\n\nThank you.`,
        has_mobile_data: 0,
        connection_id: selectedConnectionId,
        has_rental: 1,
      };
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/pdf/generate-and-send`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${tok}` },
        body: JSON.stringify(body),
      });
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        const textResponse = await response.text();
        throw new Error(`Server returned non-JSON response (Status ${response.status}).`);
      }
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.message || result.error || "Failed to send contract");
      alert("✅ Contract sent for signature!");
      setAgreementId(result.agreement_id);
      await QuoteProgressService.saveStep({ quoteId: selectedConnectionId, stepName: "rental", completed: true, actions: { emailed: true } });
    } catch (error) {
      console.error("Error sending to Adobe Sign:", error);
      alert("Error sending contract for signature: " + error.message);
    } finally {
      setIsGeneratingAdobePDF(false);
      setIsPdfMode(false);
      setIsGeneratingPDF(false);
    }
  };

  const sendReminder = async (agreementId) => {
    if (!window.confirm("Send reminder email to signer?")) return;
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adobe/agreements/${agreementId}/remind`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      const result = await response.json();
      if (result.success) alert("Reminder sent successfully!");
      else alert("Failed to send reminder: " + result.message);
    } catch (error) {
      alert("Error sending reminder email.");
    }
  };

  const downloadSignedContract = async (agreementId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adobe/agreements/${agreementId}/download`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `signed-contract-${agreementId}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        alert("Error downloading signed document");
      }
    } catch (error) {
      alert("Failed to download signed contract");
    }
  };

  function numberToWords(num) {
    const ones = ["", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE", "TEN",
      "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN", "NINETEEN"];
    const tens = ["", "", "TWENTY", "THIRTY", "FORTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY"];
    if (num === 0) return "ZERO";
    if (num < 20) return ones[num];
    if (num < 100) return `${tens[Math.floor(num / 10)]}${num % 10 ? " " + ones[num % 10] : ""}`;
    return num.toString();
  }

  const generatePDF = async () => {
    try {
      setIsGeneratingPDF(true);
      setIsPdfMode(true);
      await new Promise((resolve) => setTimeout(resolve, 500));
      const element = pdfRef.current;
      if (!element) {
        setIsGeneratingPDF(false);
        setIsPdfMode(false);
        return;
      }
      const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <script src="https://cdn.tailwindcss.com"></script>
  <style>
    body { font-family: Arial, Helvetica, sans-serif; color: #111; background: #fff; margin: 0; padding: 0; }
    .page-break-after { page-break-after: always !important; break-after: page !important; }
    * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  </style>
</head>
<body>
  <div class="pdf-content">${element.innerHTML}</div>
</body>
</html>`;
      const tok = localStorage.getItem("authToken");
      if (!tok) {
        alert("Authentication token missing. Please log in again.");
        setIsGeneratingPDF(false);
        setIsPdfMode(false);
        return;
      }
      const pdfHtmlContent = htmlContent
        .replace(/\{\{Sig1_es_:signer1:signature\}\}/g, "[SIGNATURE AREA]")
        .replace(/\{\{Int1_es_:signer1:initials\}\}/g, "[INITIALS AREA]");
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/pdf/generate`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${tok}` },
        body: JSON.stringify({ html: pdfHtmlContent, filename: `rental_${formData.companyName || "document"}` }),
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || "Failed to generate PDF");
      }
      const pdfBlob = await response.blob();
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `rental_${formData.companyName || "document"}.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
      await QuoteProgressService.saveStep({ quoteId: selectedConnectionId, stepName: "rental", completed: true, actions: { downloaded: true } });
      alert("✅ PDF generated successfully!");
    } catch (error) {
      alert("Error generating rental PDF. Please try again.");
    } finally {
      setIsGeneratingPDF(false);
      setIsPdfMode(false);
    }
  };

  const handleSortCodeChange = (index, value) => {
    const newSortCode = [...formData.sortCode];
    newSortCode[index] = value;
    setFormData((prev) => ({ ...prev, sortCode: newSortCode }));
  };

  const handleAccountNumberChange = (index, value) => {
    const newAccountNumber = [...formData.accountNumber];
    newAccountNumber[index] = value;
    setFormData((prev) => ({ ...prev, accountNumber: newAccountNumber }));
  };

  const [ticks, setTicks] = useState({
    mobile: "NEW", t54w: "NEW", t57w: "NEW", t58w: "NEW",t88:"NEW",t85:"NEW",t87:"NEW",grandstream3470:"NEW",grandstream3480:"NEW",cisco:"NEW",
    ipDectHandset: "NEW", ucmpbx: "NEW", wifi: "NEW", poe: "NEW",
    fibre: "NEW", licence: "NEW", reporting: "NEW", recording: "NEW",
  });

  const handleTickChange = (key, option) => {
    setTicks((prev) => ({ ...prev, [key]: option }));
  };
   const PdfInput = ({ value, onChange, maxLength, className }) => {
    return isPdfMode ? (
      <div
        className="flex items-center justify-center"
        style={{
          height: "24px",
          width: "24px",
          fontSize: "12px", // Smaller font to fit form boxes
          fontFamily: "monospace",
          lineHeight: "1",
          // Keep borders to match PDF form appearance
          border: "1px solid #333",
          background: "white",
          margin: "0",
          padding: "2px 3px 4px 3px", // top right bottom left - extra bottom padding
          boxSizing: "border-box",
        }}
      >
        <span
          style={{
            display: "block",
            marginTop: "-1px",
            color: "#000", // Ensure text is black
            fontWeight: "500", // Slightly bolder for visibility
          }}
        >
          {value || ""}
        </span>
      </div>
    ) : (
      <input
        type="text"
        maxLength={maxLength}
        value={value}
        onChange={onChange}
        className={className}
      />
    );
  };

  // Helper: render a tick cell
  const TickCell = ({ tickKey, value }) => (
    <td className="border-r border-gray-400 text-center" style={{ padding: "1px 2px" }}>
      {isPdfMode
        ? (ticks[tickKey] === value ? "x" : "")
        : <input type="checkbox" checked={ticks[tickKey] === value} onChange={() => handleTickChange(tickKey, value)} />}
    </td>
  );
  const TickCellLast = ({ tickKey, value }) => (
    <td className="text-center" style={{ padding: "1px 2px" }}>
      {isPdfMode
        ? (ticks[tickKey] === value ? "x" : "")
        : <input type="checkbox" checked={ticks[tickKey] === value} onChange={() => handleTickChange(tickKey, value)} />}
    </td>
  );
  const PageFooter = ({ pageNumber }) => (
    
  
  <div className="w-full">
  
    <p style={{ fontSize: "9px", color: "#9ca3af", marginTop: "4px" }}>
      HEUD1024 | Page {pageNumber}
    </p>
  </div>
);

  if (!showMainForm) {
    return (
      <div>
        {/* Action Buttons */}
        <div className="flex justify-end mb-2">
          <button
            onClick={generatePDF}
            disabled={isGeneratingPDF}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            <Download size={16} />
            {isGeneratingPDF ? "Generating..." : "Download PDF"}
          </button>
          <button
            onClick={sendToAdobeSign}
            disabled={isGeneratingAdobePDF}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 ml-2"
          >
            {isGeneratingAdobePDF ? "Sending..." : "Send for Adobe"}
          </button>
        </div>

        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-10 py-10">
          <div id="pdf-content" className="w-full max-w-4xl bg-white" ref={pdfRef}>

            {/* ── PAGE 1: Title Page ── */}
            <div
              className="flex flex-col justify-between items-center bg-white"
              style={{ minHeight: "297mm", padding: "40mm 20mm" }}
            >
              <div className="w-full border-t-2 border-gray-800"></div>
              <div className="flex flex-col justify-center items-center flex-grow">
                <h1 className="text-5xl font-bold text-[#1F4E79] text-center">
                  Universal Rental Document
                </h1>
                <h2 className="mt-12 text-7xl font-bold text-gray-400">Page 1</h2>
               
              </div>
                <PageFooter pageNumber={1} />
              <div className="w-full border-t-2 border-gray-800">
                
              </div>
              
            </div>

            {/* ── PAGE 2: Checklist ── */}
            <div className="p-8 bg-white text-gray-900 text-justify space-y-2 text-xs leading-relaxed page-break-after">
              <div className="bg-[#1F4E79] text-white font-bold text-center py-3 rounded-t-md shadow-md">
                Checklist for Business Finance Customers
              </div>
              <p>1. Read your business finance agreement carefully before signing it. Never sign a business finance agreement which is not fully complete. Retain copies of all documentation.</p>
              <p>2. Ensure that the final contract:.</p>
              <p>&nbsp;&nbsp;&nbsp;• Corresponds with any verbal or written quotation on the rental amount and period of hire;</p>
              <p>&nbsp;&nbsp;&nbsp;• Accurately reflects what you are agreeing to pay for, including any maintenance or services included in the repayments;</p>
              <p>&nbsp;&nbsp;&nbsp;• Accurately describes the equipment You are expecting to receive (e.g., whether it is new or used) and that its working life is appropriate to the length of the finance agreement.</p>
              <p>3. Make it clear who has the authority within Your own organisation to sign the agreement.</p>
              <p>4. Make sure You understand and agree with all terms and conditions of the business finance agreement and, if  You are unsure, ask for these to be explained or seek advice.</p>
              <p>5. Make sure You understand all the costs involved and whether these will change during the course of the business finance agreement.</p>
              <p>6.Check that the supplier of the equipment is reputable.</p>
              <p>7.Understand whether there are any notice period or settlement terms required to terminate the agreement.</p>
              <p>8.If there is a maintenance or service contract which is separate to the finance agreement, check that the length, start date, notice period, and settlement terms of the two agreements is the same, and if not,that You are happy with this.</p>
              <p>9.If the name of the leasing company contracting with You is not shown on the agreement, ensure that You are informed at the earliest possible time.</p>
              <p>10.Check whether the funder is a member of the FLA, as all asset finance members adhere to the FLA Business Finance Code.</p>
              <p>11.If any amendments are made to the business finance agreement or a further agreement is required to replace an existing agreement, do not sign it until You have made the same checks as You did for the original agreement.</p>
              <p>12. If a new business finance agreement includes an element of refinancing from a previous agreement with a different provider, check that the settlement figure provided by the former provider matches the refinancing figure used by the new provider.</p>
              
               {/* Add a spacer div instead */}
              <div style={{ height: '120px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 2
                </p>
              </div>
            </div>

            {/* ── PAGE 3: All Form Sections in ONE page-break-after wrapper ── */}
            <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>

              {/* Customer Number & Agreement Number */}
              <div style={{ display: "flex", gap: "32px", marginBottom: "8px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", flex: 1 }}>
                  <span style={{ fontWeight: "600", whiteSpace: "nowrap" }}>Customer Number :</span>
                  {isPdfMode
                    ? <div style={{ flex: 1, borderBottom: "1px solid #555" }}>{formData.customerNumber || " "}</div>
                    : <input type="text" name="customerNumber" value={formData.customerNumber} onChange={handleChange}
                        style={{ flex: 1, borderBottom: "1px solid #555", outline: "none", fontSize: "8px" }} />}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", flex: 1 }}>
                  <span style={{ fontWeight: "600", whiteSpace: "nowrap" }}>Agreement Number :</span>
                  {isPdfMode
                    ? <div style={{ flex: 1, borderBottom: "1px solid #555" }}>{formData.agreementNumber || " "}</div>
                    : <input type="text" name="agreementNumber" value={formData.agreementNumber} onChange={handleChange}
                        style={{ flex: 1, borderBottom: "1px solid #555", outline: "none", fontSize: "8px" }} />}
                </div>
              </div>

              {/* COMPANY Section */}
              <div style={{ border: "1px solid #9ca3af", marginBottom: "4px" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                  COMPANY ("We", "Us", "Our", "Owner")
                </div>
                <div style={{ padding: "3px 4px", borderBottom: "1px solid #9ca3af", lineHeight: "1.3" }}>
                  We will be a Finance Company which is entirely separate from the Supplier, Our details will be inserted below and notified to You when this Agreement is accepted. You agree to be bound by the terms and conditions here and over the page upon acceptance by Us.
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "90px" }}>Company's Name</td>
                      <td style={{ padding: "2px 4px" }}>
                        {isPdfMode ? <span>{formData.customerName || " "}</span>
                          : <input type="text" name="customerName" onChange={(e) => setFormData({ ...formData, customerName: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Address</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>
                        {isPdfMode ? <span>{formData.companyAddress || " "}</span>
                          : <input type="text" name="companyAddress" value={formData.companyAddress}
                              onChange={(e) => setFormData({ ...formData, companyAddress: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "55px" }}>Postcode</td>
                      <td style={{ padding: "2px 4px", width: "80px" }}>
                        {isPdfMode ? <span>{formData.companyPostcode || " "}</span>
                          : <input type="text" name="companyPostcode" value={formData.companyPostcode}
                              onChange={(e) => setFormData({ ...formData, companyPostcode: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* CUSTOMER Section */}
              <div style={{ border: "1px solid #9ca3af", marginBottom: "4px" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                  CUSTOMER ("You", "Your", "Hirer")
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "90px" }}>Name</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>
                        {isPdfMode ? <span>{formData.companyName || " "}</span>
                          : <input type="text" name="companyName" value={formData.companyName}
                              onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "65px" }}>Co.Reg No.</td>
                      <td style={{ padding: "2px 4px", width: "90px" }}>
                        {isPdfMode ? <span>{formData.coRegNo || " "}</span>
                          : <input type="text" name="coRegNo" value={formData.coRegNo}
                              onChange={(e) => setFormData({ ...formData, coRegNo: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>
                        Trading As <span style={{ fontWeight: "normal", fontStyle: "italic" }}>(if applicable)</span>
                      </td>
                      <td style={{ padding: "2px 4px" }} colSpan={3}>
                        {isPdfMode ? <span>{formData.tradingAs || " "}</span>
                          : <input type="text" name="tradingAs" value={formData.tradingAs}
                              onChange={(e) => setFormData({ ...formData, tradingAs: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Registered Address</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>
                        {isPdfMode ? <span>{formData.fullAddress || " "}</span>
                          : <input type="text" name="fullAddress" value={formData.fullAddress}
                              onChange={(e) => setFormData({ ...formData, fullAddress: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Reg. Postcode</td>
                      <td style={{ padding: "2px 4px" }}>
                        {isPdfMode ? <span>{formData.postcode || " "}</span>
                          : <input type="text" name="postcode" value={formData.postcode}
                              onChange={(e) => setFormData({ ...formData, postcode: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>
                        Location of Products<br />
                        <span style={{ fontWeight: "normal", fontStyle: "italic" }}>(if different from above)</span>
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>
                        {isPdfMode ? <span>{formData.installation_address || " "}</span>
                          : <input type="text" name="locationOfProducts" value={formData.installation_address}
                              onChange={(e) => setFormData({ ...formData, installation_address: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Postcode</td>
                      <td style={{ padding: "2px 4px" }}>
                        {isPdfMode ? <span>{formData.locationPostcode || " "}</span>
                          : <input type="text" name="locationPostcode" value={formData.locationPostcode}
                              onChange={(e) => setFormData({ ...formData, locationPostcode: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Contact Name</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>
                        {isPdfMode ? <span>{formData.managerName || " "}</span>
                          : <input type="text" name="contactName" value={formData.managerName}
                              onChange={(e) => setFormData({ ...formData, managerName: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Tel. No.</td>
                      <td style={{ padding: "2px 4px" }}>
                        {isPdfMode ? <span>{formData.mainTelNo || " "}</span>
                          : <input type="text" name="mainTelNo" value={formData.mainTelNo}
                              onChange={(e) => setFormData({ ...formData, mainTelNo: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Email</td>
                      <td style={{ padding: "2px 4px" }} colSpan={3}>
                        {isPdfMode ? <span>{formData.directorEmail || " "}</span>
                          : <input type="email" name="directorEmail" value={formData.directorEmail}
                              onChange={(e) => setFormData({ ...formData, directorEmail: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", fontWeight: "600" }} colSpan={4}>
                        Non-corporate customers (Personal details of proprietor or one partner)
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Name</td>
                      <td style={{ padding: "2px 4px" }} colSpan={3}>
                        {isPdfMode ? <span>{formData.personalName || " "}</span>
                          : <input type="text" name="personalName" value={formData.personalName}
                              onChange={(e) => setFormData({ ...formData, personalName: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Private Address</td>
                      <td style={{ padding: "2px 4px" }} colSpan={3}>
                        {isPdfMode ? <span>{formData.privateAddress || " "}</span>
                          : <input type="text" name="privateAddress" value={formData.privateAddress}
                              onChange={(e) => setFormData({ ...formData, privateAddress: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr>
                    <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Postcode</td>
                    <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>
                      {isPdfMode ? <span>{formData.personalPostcode || " "}</span>
                        : <input type="text" name="personalPostcode" value={formData.personalPostcode}
                            onChange={(e) => setFormData({ ...formData, personalPostcode: e.target.value })}
                            style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                    </td>
                    <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Home Tel. No.</td>
                    <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>
                      {isPdfMode ? <span>{formData.homeTelNo || " "}</span>
                        : <input type="text" name="homeTelNo" value={formData.homeTelNo}
                            onChange={(e) => setFormData({ ...formData, homeTelNo: e.target.value })}
                            style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                    </td>
                    <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Date of Birth</td>
                    <td style={{ padding: "2px 4px" }}>
                      {isPdfMode ? <span>{formData.dateOfBirth || " "}</span>
                        : <input type="text" name="dateOfBirth" value={formData.dateOfBirth}
                            onChange={(e) => setFormData({ ...formData, dateOfBirth: e.target.value })}
                            style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                    </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* SUPPLIER Section */}
              <div style={{ border: "1px solid #9ca3af", marginBottom: "4px" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                  SUPPLIER
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "90px" }}>Name</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>FIBRE TELECOMS (UK) LTD</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "65px" }}>Salesperson</td>
                      <td style={{ padding: "2px 4px" }}>
                        {isPdfMode ? <span>{formData.salesperson || " "}</span>
                          : <input type="text" name="salesperson" value={formData.salesperson}
                              onChange={(e) => setFormData({ ...formData, salesperson: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Address</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>UNIT 71, BASEPOINT BUSINESS CENTRE, SOUTHAMPTON, SO14 5FE</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>Branch</td>
                      <td style={{ padding: "2px 4px" }}>SOUTHAMPTON</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* PRODUCTS Section */}
              <div style={{ border: "1px solid #9ca3af", marginBottom: "4px" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                  PRODUCTS
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                  <tbody>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "130px" }}>Attached Schedule Reference</td>
                      <td style={{ padding: "2px 4px" }}>
                        {isPdfMode ? <span>{formData.scheduleReference || " "}</span>
                          : <input type="text" name="scheduleReference" value={formData.scheduleReference}
                              onChange={(e) => setFormData({ ...formData, scheduleReference: e.target.value })}
                              style={{ width: "100%", outline: "none", fontSize: "8px" }} />}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ padding: "2px 4px", borderBottom: "1px solid #9ca3af" }}>
                  If no attached schedule, please see Products set out below.
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <th rowSpan={2} style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center", width: "28px" }}>QTY</th>
                      <th rowSpan={2} style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center", width: "70px" }}>MANUFACTURER</th>
                      <th rowSpan={2} style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center", width: "70px" }}>MODEL</th>
                      <th rowSpan={2} style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>DESCRIPTION</th>
                      <th colSpan={3} style={{ padding: "2px", textAlign: "center", borderBottom: "1px solid #9ca3af" }}>TICK AS APPROPRIATE</th>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <th style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center", width: "30px" }}>NEW</th>
                      <th style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center", width: "40px" }}>NOT NEW</th>
                      <th style={{ padding: "2px", textAlign: "center", width: "40px" }}>RETAINED</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mobileAppUsers > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{mobileAppUsers}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>GAMMA</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>MOBILE</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>MOBILE CLIENT APPLICATION</td>
                        <TickCell tickKey="mobile" value="NEW" />
                        <TickCell tickKey="mobile" value="NOT" />
                        <TickCellLast tickKey="mobile" value="RETAIN" />
                      </tr>
                    )}
                    {totalQty(t54w) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(t54w)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>YEALINK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>T54W</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="t54w" value="NEW" />
                        <TickCell tickKey="t54w" value="NOT" />
                        <TickCellLast tickKey="t54w" value="RETAIN" />
                      </tr>
                    )}
                    {totalQty(t57w) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(t57w)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>YEALINK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>T57W</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="t57w" value="NEW" />
                        <TickCell tickKey="t57w" value="NOT" />
                        <TickCellLast tickKey="t57w" value="RETAIN" />
                      </tr>
                    )}
                    {totalQty(t58w) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(t58w)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>YEALINK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>T58W</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="t58w" value="NEW" />
                        <TickCell tickKey="t58w" value="NOT" />
                        <TickCellLast tickKey="t58w" value="RETAIN" />
                      </tr>
                    )}
                    {totalQty(t88) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(t88)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>YEALINK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>T88</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="t88" value="NEW" />
                        <TickCell tickKey="t88" value="NOT" />
                        <TickCellLast tickKey="t88" value="RETAIN" />
                      </tr>
                    )}
                     {totalQty(t85) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(t85)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>YEALINK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>T85</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="t85" value="NEW" />
                        <TickCell tickKey="t85" value="NOT" />
                        <TickCellLast tickKey="t85" value="RETAIN" />
                      </tr>
                    )}
                     {totalQty(t87) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(t87)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>YEALINK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>T87</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="t87" value="NEW" />
                        <TickCell tickKey="t87" value="NOT" />
                        <TickCellLast tickKey="t87" value="RETAIN" />
                      </tr>
                    )}

                    {totalQty(grandstream3470) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(grandstream3470)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>GRANDSTREAM</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>3470</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="grandstream3470" value="NEW" />
                        <TickCell tickKey="grandstream3470" value="NOT" />
                        <TickCellLast tickKey="grandstream3470" value="RETAIN" />
                      </tr>
                    )}

                    {totalQty(grandstream3480) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{totalQty(grandstream3480)}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>GRANDSTREAM</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>3480</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="grandstream3480" value="NEW" />
                        <TickCell tickKey="grandstream3480" value="NOT" />
                        <TickCellLast tickKey="grandstream3480" value="RETAIN" />
                      </tr>
                    )}

                    {totalQty(cisco) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{cisco.quantity}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>CISCO</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>9871</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DESK PHONE HANDSET</td>
                        <TickCell tickKey="cisco" value="NEW" />
                        <TickCell tickKey="cisco" value="NOT" />
                        <TickCellLast tickKey="cisco" value="RETAIN" />
                      </tr>
                    )}
                    {totalQty(ipDectHandset) > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{ipDectHandset.quantity}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>YEALINK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>Yealink W73H DECT</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>IP DECT CORDLESS PHONE HANDSET</td>
                        <TickCell tickKey="ipDectHandset" value="NEW" />
                        <TickCell tickKey="ipDectHandset" value="NOT" />
                        <TickCellLast tickKey="ipDectHandset" value="RETAIN" />
                      </tr>
                    )}
                    {ucmpbx.quantity > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{ucmpbx.quantity}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>UCM</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>PBX</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>UCM IP PBX</td>
                        <TickCell tickKey="ucmpbx" value="NEW" />
                        <TickCell tickKey="ucmpbx" value="NOT" />
                        <TickCellLast tickKey="ucmpbx" value="RETAIN" />
                      </tr>
                    )}
                    {wifi.quantity > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{wifi.quantity}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>DRAYTEK</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>2865LAC ROUTER</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>Draytek 2865LAC ROUTER</td>
                        <TickCell tickKey="wifi" value="NEW" />
                        <TickCell tickKey="wifi" value="NOT" />
                        <TickCellLast tickKey="wifi" value="RETAIN" />
                      </tr>
                    )}
                    {poe.quantity > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{poe.quantity}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>NETGEAR</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>GS108LP SWITCH</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>Netgear GS108LP SWITCH</td>
                        <TickCell tickKey="poe" value="NEW" />
                        <TickCell tickKey="poe" value="NOT" />
                        <TickCellLast tickKey="poe" value="RETAIN" />
                      </tr>
                    )}
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>1</td>
                      <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>FIBRE</td>
                      <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>INSTALLATION</td>
                      <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>PHONE SYSTEM INSTALLATION</td>
                      <TickCell tickKey="fibre" value="NEW" />
                      <TickCell tickKey="fibre" value="NOT" />
                      <TickCellLast tickKey="fibre" value="RETAIN" />
                    </tr>
                    {mobileAppUsers > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{mobileAppUsers}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>GAMMA</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>LICENCE</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>LIFETIME LICENCE</td>
                        <TickCell tickKey="licence" value="NEW" />
                        <TickCell tickKey="licence" value="NOT" />
                        <TickCellLast tickKey="licence" value="RETAIN" />
                      </tr>
                    )}
                    {mobileAppUsers > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{mobileAppUsers}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>TOLLRING</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>BUSINESS</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>CALL REPORTING</td>
                        <TickCell tickKey="reporting" value="NEW" />
                        <TickCell tickKey="reporting" value="NOT" />
                        <TickCellLast tickKey="reporting" value="RETAIN" />
                      </tr>
                    )}
                    {mobileAppUsers > 0 && (
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>{mobileAppUsers}</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>TOLLRING</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>BUSINESS</td>
                        <td style={{ padding: "2px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>CALL RECORDING</td>
                        <TickCell tickKey="recording" value="NEW" />
                        <TickCell tickKey="recording" value="NOT" />
                        <TickCellLast tickKey="recording" value="RETAIN" />
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* TERMS OF HIRE Section */}
              <div style={{ border: "1px solid #9ca3af" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                  TERMS OF HIRE
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", width: "38%" }}>
                        This agreement is for a Minimum Period of
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600", width: "24%" }}>
                        {numberToWords(Number(leaseCalculatorData.paymentProfile))}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", width: "24%" }}>
                        You will pay Us Rentals every
                      </td>
                      <td style={{ padding: "2px 4px" }}>
                        {isPdfMode
                          ? <span style={{ fontWeight: "600" }}>{formData.rentalFrequency || "MONTH"}</span>
                          : <select name="rentalFrequency" value={formData.rentalFrequency} onChange={handleInputChange}
                              style={{ border: "1px solid #9ca3af", borderRadius: "2px", padding: "0 2px", fontSize: "8px", background: "white" }}>
                              <option value="MONTH">MONTH</option>
                              <option value="QUARTER">QUARTER</option>
                              <option value="YEAR">YEAR</option>
                            </select>}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px" }} colSpan={4}>By signing this Agreement You agree to pay Us:</td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>an initial rental of</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>
                        £ {leaseCalculatorData.adjustedRental}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>+ VAT</td>
                      <td style={{ padding: "2px 4px" }}></td>
                    </tr>
                    <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>followed by a minimum of</td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af", fontWeight: "600" }}>
                        {numberToWords(Number(leaseCalculatorData.paymentProfile) - 1)}
                      </td>
                      <td style={{ padding: "2px 4px", borderRight: "1px solid #9ca3af" }}>Rentals of</td>
                      <td style={{ padding: "2px 4px", fontWeight: "600" }}>
                        £ {leaseCalculatorData.adjustedRental} + VAT
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style={{ borderTop: "1px solid #9ca3af", padding: "3px 4px" }}>
                  <p style={{ fontWeight: "bold", border: "1px solid black", padding: "2px 4px", marginBottom: "3px", lineHeight: "1.3" }}>
                    On expiry of the Minimum Period, Rentals will continue to be payable at the same frequency and in the same amount as the last Rental shown above.
                  </p>
                  <p style={{ lineHeight: "1.4" }}>
                    The Rentals can be varied if tax rates change, or You change the method of Your payment (refer to Clause 2). Also if the maintenance charges change (refer to Clause 5). We may collect the cost of insurance for the Products that We arrange (see Clause 4). If You terminate this Agreement under Clause 10 You will pay the sums that Clause refers to. The Minimum Period starts on the day We sign this Agreement. An Administration Fee of £150 plus VAT is payable on Our acceptance of this Agreement and will be collected with the Initial Rental. An annual customer service charge of £40 plus VAT shall be payable in arrears on each anniversary of this Agreement (refer to clause 2.5).
                  </p>
                </div>
              </div>
              {(() => {
                const productRowCount = [
                  mobileAppUsers > 0 ? 1 : 0,   // mobile
                  totalQty(t54w) > 0 ? 1 : 0,
                  totalQty(t57w) > 0 ? 1 : 0,
                  totalQty(t58w) > 0 ? 1 : 0,
                  totalQty(t85) > 0 ? 1 : 0,
                  totalQty(t87) > 0 ? 1 : 0,
                  totalQty(t88) > 0 ? 1 : 0,
                  totalQty(grandstream3470) > 0 ? 1 : 0,
                  totalQty(grandstream3480) > 0 ? 1 : 0,
                  totalQty(ipDectHandset) > 0 ? 1 : 0,
                  ucmpbx.quantity > 0 ? 1 : 0,
                  wifi.quantity > 0 ? 1 : 0,
                  poe.quantity > 0 ? 1 : 0,
                  1,                             // fibre (always shown)
                  mobileAppUsers > 0 ? 1 : 0,   // licence
                  mobileAppUsers > 0 ? 1 : 0,   // reporting
                  mobileAppUsers > 0 ? 1 : 0,   // recording
                ].reduce((a, b) => a + b, 0);

                const spacerHeight = Math.max(0, 160 - (productRowCount * 13));
                return <div style={{ height: `${spacerHeight}px` }} />;
              })()}
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 3
                </p>
              </div>
            </div>
            
            {/* ── END PAGE 3 ── */}

            {/* ── PAGE 4 MAINTENANCE ── */}
            <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>

              {/* MAINTENANCE */}
              <div style={{ border: "2px solid #1F4E79", marginBottom: "8px" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                  MAINTENANCE
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: "4px 6px", borderRight: "1px solid #9ca3af", fontWeight: "600", lineHeight: "1.4" }}>
                        If Your Rental includes maintenance charges We draw Your attention to Clause 5 overleaf.
                      </td>
                      <td style={{ padding: "4px 6px", borderRight: "1px solid #9ca3af", background: "#f0ede8", width: "130px", lineHeight: "1.3" }}>
                        Maintenance Charge included in each Rental
                      </td>
                      <td style={{ padding: "4px 6px", borderRight: "1px solid #9ca3af", width: "16px" }}>£</td>
                      <td style={{ padding: "4px 6px", borderRight: "1px solid #9ca3af", width: "120px" }}>
                        {isPdfMode ? (
                          <span>{formData.maintenanceCharge || " "}</span>
                        ) : (
                          <input
                            type="number" step="0.01" min="0"
                            value={formData.maintenanceCharge || ""}
                            onChange={(e) => setFormData({ ...formData, maintenanceCharge: e.target.value })}
                            style={{ width: "100%", fontSize: "8px", outline: "none", border: "none" }}
                            placeholder="0.00"
                          />
                        )}
                      </td>
                      <td style={{ padding: "4px 6px", width: "40px" }}>+ VAT</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* ADDITIONAL PROVISIONS */}
              <div style={{ border: "2px solid #1F4E79", marginBottom: "8px" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                  ADDITIONAL PROVISIONS
                </div>
                <div style={{ background: "white", minHeight: "80px", padding: "4px 6px", borderBottom: "1px solid #9ca3af" }}>
                  {isPdfMode ? (
                    <div style={{ minHeight: "80px" }}>{formData.additionalProvisions || " "}</div>
                  ) : (
                    <textarea
                      name="additionalProvisions"
                      rows="5"
                      style={{ width: "100%", border: "none", fontSize: "8px", outline: "none", resize: "none", background: "white", boxSizing: "border-box" }}
                      value={formData.additionalProvisions || ""}
                      onChange={handleInputChange}
                    />
                  )}
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "55%" }}></td>
                      <td style={{ background: "#f0ede8", padding: "3px 6px", borderRight: "1px solid #9ca3af", borderLeft: "1px solid #9ca3af", whiteSpace: "nowrap", textAlign: "right" }}>
                        Confirmed by You (please sign)
                      </td>
                      <td style={{ background: "white", width: "120px", padding: "3px 6px" }}></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* DATA PROTECTION */}
              <div style={{ border: "2px solid #1F4E79", marginBottom: "8px" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                  DATA PROTECTION
                </div>
                <div style={{ padding: "4px 6px" }}>
                  <p style={{ border: "4px solid #1F4E79", padding: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                    Please see the attached Use of Personal Data Statement for information about how We collect, share, process use and protect personal data. If you provide Us with personal information about any other individuals (such as directors of Your company or Your partner/spouse) please provide them with a copy of the Use of Personal Data Statement.
                  </p>
                  <div style={{ border: "4px solid #1F4E79", padding: "6px", lineHeight: "1.4" }}>
                    <p style={{ marginBottom: "4px" }}>
                      By signing below the Customer is confirming that it is entering into this Agreement for the purpose of the business carried out by the Customer or which the Customer intends to carry on. The Customer also confirms that it has not said or done anything nor given the Owner anything which contradicts this.
                    </p>
                    <p>
                      The Customer confirms that all the information the Customer has provided is true and correct and that the Customer is making this Agreement in the course of the Customer's business. The Customer has selected the Products and agrees that the terms of Clause 6, the exclusion of liability clause, are reasonable.
                    </p>
                  </div>
                </div>
              </div>

              {/* DECLARATION */}
              <div style={{ border: "2px solid #1F4E79", padding: "6px", marginBottom: "8px", lineHeight: "1.5" }}>
                <p style={{ fontWeight: "bold", marginBottom: "2px" }}>Declaration for exemption relating to businesses.</p>
                <p>Articles 60C and 60O of the Financial Services and Markets Act 2000 (Regulated Activities) Order 2001</p>
                <p style={{ marginTop: "4px" }}>I/We* are* entering this agreement wholly or predominantly for the purposes of a business carried on by me/us* or intended to be carried by me/us.*</p>
                <p style={{ marginTop: "4px" }}>I/We* understand that I/we* will not have the benefit of the protection and remedies that would be available to me/us* under the Financial Services and Markets Act 2000 or under the Consumer Credit Act 1974 if this agreement were a regulated agreement under those Acts.</p>
                <p style={{ marginTop: "4px" }}>I am/We are* that, if I am/we are* in any doubt as to the consequences of the agreement not being regulated by the Financial Services and Markets Act 2000 or the Consumer Credit Act 1974 we should seek independent legal advice. *Delete as appropriate</p>
              </div>

              {/* YOUR SIGNATURE + SETTLEMENT DETAILS - side by side */}
              <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>

                {/* LEFT COLUMN: YOUR SIGNATURE + YOUR DETAILS stacked */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px" }}>

                  {/* YOUR SIGNATURE */}
                  <div style={{ border: "2px solid #1F4E79" }}>
                    <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                      YOUR SIGNATURE
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                          <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8", width: "80px" }}>Signature(s)</td>
                          <td style={{ padding: "3px 4px", height: "28px" }}>{"{{Sig1_es_:signer1:signature}}"}</td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                          <td colSpan={2} style={{ padding: "3px 4px", lineHeight: "1.4" }}>
                            Under this Agreement the Products do not become Your property and You must not sell them.
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8" }}>Date</td>
                          <td style={{ padding: "3px 4px" }}>
                            {isPdfMode ? (
                              <span>{formData.date || " "}</span>
                            ) : (
                              <input
                                type="date"
                                value={formData.date || ""}
                                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                                style={{ border: "none", fontSize: "8px", outline: "none", width: "100%" }}
                              />
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* YOUR DETAILS */}
                  <div style={{ border: "2px solid #1F4E79" }}>
                    <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                      YOUR DETAILS
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                          <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8", width: "80px" }}>Name</td>
                          <td style={{ padding: "3px 4px" }}>
                            {isPdfMode ? (
                              <span>{formData.managerName || " "}</span>
                            ) : (
                              <input type="text" value={formData.managerName || ""}
                                onChange={(e) => setFormData({ ...formData, managerName: e.target.value })}
                                style={{ width: "100%", fontSize: "8px", outline: "none", border: "none" }} />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8" }}>Position</td>
                          <td style={{ padding: "3px 4px" }}>
                            {isPdfMode ? (
                              <span>{formData.position || " "}</span>
                            ) : (
                              <input type="text" value={formData.position || ""}
                                onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                                style={{ width: "100%", fontSize: "8px", outline: "none", border: "none" }} />
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>{/* end left column */}

                {/* RIGHT COLUMN: SETTLEMENT DETAILS */}
                <div style={{ flex: 1, border: "2px solid #1F4E79" }}>
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                    SETTLEMENT DETAILS
                  </div>
                  <div style={{ padding: "3px 4px", borderBottom: "1px solid #9ca3af", lineHeight: "1.4" }}>
                    The Payments payable under this Agreement include the Amounts set out be- low to settle the commitment for existing products under agreements between You and:
                  </div>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8", width: "110px" }}>Name of Finance Company</td>
                        <td style={{ padding: "3px 4px" }}>
                          {isPdfMode ? (
                            <span>{formData.financeCompany || " "}</span>
                          ) : (
                            <input type="text" value={formData.financeCompany || ""}
                              onChange={(e) => setFormData({ ...formData, financeCompany: e.target.value })}
                              style={{ width: "100%", fontSize: "8px", outline: "none", border: "none" }} />
                          )}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8" }}>Agreement Number</td>
                        <td style={{ padding: "3px 4px" }}>
                          {isPdfMode ? (
                            <span>{formData.agreementNumber || " "}</span>
                          ) : (
                            <input type="text" value={formData.agreementNumber || ""}
                              onChange={(e) => setFormData({ ...formData, agreementNumber: e.target.value })}
                              style={{ width: "100%", fontSize: "8px", outline: "none", border: "none" }} />
                          )}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #9ca3af" }}>
                        <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8" }}>Amount</td>
                        <td style={{ padding: "3px 4px" }}>
                          £{" "}
                          {isPdfMode ? (
                            <span>{formData.amount || " "}</span>
                          ) : (
                            <input type="text" value={formData.amount || ""}
                              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                              style={{ width: "90%", fontSize: "8px", outline: "none", border: "none" }} />
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: "3px 4px", lineHeight: "1.4" }}>
                          The Supplier undertakes to settle this commitment on Your behalf upon acceptance of this Agreement. By signing this Agreement You authorise Us to pay the Supplier the Amounts and in doing so this is the extent of Our liability.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>{/* end flex row */}

              {/* FOR INTERNAL USE ONLY */}
              <hr style={{ border: "none", borderTop: "2px solid #333", marginBottom: "6px" }} />
              <div style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", marginBottom: "6px", fontSize: "11px" }}>
                For Internal Use Only
              </div>

              {/* THE COMPANY SIGNATURE */}
              <div style={{ border: "2px solid #1F4E79" }}>
                <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0" }}>
                  THE COMPANY SIGNATURE
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8", width: "100px", verticalAlign: "top" }}>
                        For and on behalf of<br />The Company
                      </td>
                      <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", height: "36px" }}></td>
                      <td style={{ padding: "3px 4px", borderRight: "1px solid #9ca3af", background: "#f0ede8", width: "90px" }}>
                        Date of Agreement
                      </td>
                      <td style={{ padding: "3px 4px", width: "130px" }}>
                        {isPdfMode ? (
                          <span>{formData.agreementDate || " "}</span>
                        ) : (
                          <input
                            type="date"
                            value={formData.agreementDate || ""}
                            onChange={(e) => setFormData({ ...formData, agreementDate: e.target.value })}
                            style={{ border: "none", fontSize: "8px", outline: "none", width: "100%" }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

             
              <div style={{ height:'180px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 4
                </p>
              </div>


            </div>
             {/* ── PAGE 5 TERMS ── */}
              {/* ── T&C PAGE 1: Sections 1 & 2 ── */}
              <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>
                <div style={{ border: "1px solid #9ca3af" }}>
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                    TERMS AND CONDITIONS
                  </div>
                  <div style={{ padding: "6px 8px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>

                    {/* Column 1 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>1.&nbsp;&nbsp;THE AGREEMENT AND DELIVERY</div>
                      <p style={{ marginBottom: "3px" }}>1.1&nbsp;&nbsp;We are letting and You are taking on hire the Products for use in Your business on the terms 
                        set out.</p>
                      <p style={{ marginBottom: "3px" }}>1.2&nbsp;&nbsp;The Agreement starts when We sign it and the Initial Rental and Administration Fee are due and payable at that time. The hiring continues until it is ended by You or Us in accordance with the provisions of this Agreement.</p>
                      <p style={{ marginBottom: "3px" }}>1.3&nbsp;&nbsp;If You wish to end the Agreement at the end of the Minimum Period then You must give Us at least 90 days' written notice to terminate the Agreement, such notice to expire no earlier than the last day of the Minimum Period. On expiry of the Minimum Period, provided that You have not served notice to terminate this Agreement and We have not terminated the hiring of the Products hereunder then the hiring of the Products will automatically continue thereafter until either party gives to the other party 90 days written notice to terminate the hiring of the Products, such notice to expire on a Rental payment date.</p>
                      <p style={{ marginBottom: "3px" }}>1.4&nbsp;&nbsp;All the terms of hire of the Products are in this Agreement and only variations signed by us both are effective.</p>
                      <p style={{ marginBottom: "6px" }}>1.5&nbsp;&nbsp;You must make all arrangements for the delivery, installation and testing of the Products and their connection to any network. You must inspect the Products on delivery, and inform Us in writing within 5 days if they are defective, incomplete or not as specified otherwise You will have deemed to have fully accepted them.</p>

                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>2.&nbsp;&nbsp;PAYMENTS</div>
                      <p style={{ marginBottom: "3px" }}>2.1&nbsp;&nbsp;It is an essential term of this Agreement that You pay to Us all the Rentals and any other sums on the due dates in full and without retention by You and doing so is of the essence of this Agreement. VAT at the applicable prevailing rate must also be paid by You. All amounts payable by You under this Agreement must be made without any deduction, withholding, set-off, counterclaim or appropriation.</p>
                      <p style={{ marginBottom: "3px" }}>2.2&nbsp;&nbsp;Unless otherwise agreed before You sign this Agreement all payments by You must be paid by direct debit. If You choose after signing this Agreement to pay by other means, and We agree, then You must pay Us a non-direct debit fee a minimum of £50 plus VAT for each Rental not yet due and payable.</p>
                      <p style={{ marginBottom: "3px" }}>2.3&nbsp;&nbsp;You agree that the Rentals have been calculated on the assumption that the bases, rates and treatment of corporation tax, capital allowances and VAT allowed or in force at the date of this Agreement will remain unchanged for the period of the Agreement and that We will be entitled to reclaim any VAT in relation to the purchase price of the Products and charge VAT in respect of each Rental. If after the commencement of this Agreement there are any changes in the above assumptions and/or such assumptions proved to be incorrect You shall pay Us, if called upon to do so, by way of increased Rentals or lump sum payable on demand, such sum or sums as are required to place Us in the financial position (as regards this Agreement) which is expected had not such changes occurred and/or such assumptions had not proven to be incorrect. Our certificate of the increased Rentals or lump sum as the case may be shall be final and binding upon You and shall remain payable notwithstanding the termination of this Agreement for whatever reason.</p>
                    </div>

                    {/* Column 2 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <p style={{ marginBottom: "3px" }}>2.4&nbsp;&nbsp;If You do not pay any Rental or other sum due under this Agreement, on the due date for payment, in addition to Our other rights, You will also pay interest from day to day on the unpaid amount at the rate of 6% above Bank of England Base Rate or 2.5% of outstanding rentals, whichever is the greater, from time to time, after as well as before any judgement, from the date the payment was due until the day that We receive it.</p>
                      <p style={{ marginBottom: "6px" }}>2.5&nbsp;&nbsp;An annual customer service charge of £40 plus VAT shall be payable in arrears on each anniversary of this Agreement to cover our costs in managing Your account including making available (a) information about this Agreement required by You and Your agents for the purposes of Your business and (b) other administrative services.</p>

                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>3.&nbsp;&nbsp;USING THE PRODUCTS</div>
                      <p style={{ marginBottom: "3px" }}>3.1&nbsp;&nbsp;If the Products include software You must agree with the software supplier the arrangements for use of it and get the warranties You require from that person. You must ensure the software is suitable for You and that You have all the necessary licences to use and operate it. As You deal directly with the supplier for the supply of the software You agree that it is reasonable for Us to exclude any liability relating to the software. You agree to indemnify Us and keep Us indemnified against any claims, costs, expenses, damages, liabilities and legal fees on a full indemnity basis that We may suffer, sustain or incur as a result of any dispute that may arise, in any way whatsoever, in connection with the software or the software licence.</p>
                      <p style={{ marginBottom: "3px" }}>3.2&nbsp;&nbsp;Upon request and at Your cost, We will give all reasonable assistance to extend to You, so far as We are legally able, the benefit of any manufacturer's guarantees, conditions or warranties in relation to the Products.</p>
                      <p style={{ marginBottom: "3px" }}>3.3&nbsp;&nbsp;You are responsible for keeping the Products in good condition at Your own cost. All damage, other than fair wear and tear, must be made good. All replacement and attached parts become part of the Products and Ours. No maintenance or other services are provided by Us under this Agreement.</p>
                      <p style={{ marginBottom: "3px" }}>3.4&nbsp;&nbsp;You must keep the Products safe and use them safely and in accordance with the law and the manufacturer's recommendations, and only for purpose for which they are designed, or built, or are suitable. Any modifications required by law or otherwise will be completed at Your expense.</p>
                      <p style={{ marginBottom: "3px" }}>3.5&nbsp;&nbsp;You must keep the Products in Your possession at the Location, except when they are being repaired, but You must not allow any repairer's lien to arise. You must not deal with the Products or transfer or assign them or any part of them. You must not hold Yourself out as the owner of the Products; nor may You claim capital allowances.</p>
                      <p style={{ marginBottom: "3px" }}>3.6&nbsp;&nbsp;You agree to indemnify Us and keep Us fully indemnified on demand against any loss, damage, proceedings, claims, costs or expenses including legal costs on a full indemnity basis arising directly or indirectly from Your hiring, possession, operation or use of the Products under this Agreement except for death or personal injury caused by Our negligence. The provisions of this clause shall continue in full force and effect notwithstanding the termination of this Agreement for any reason.</p>
                      <p style={{ marginBottom: "3px" }}>3.7&nbsp;&nbsp;You may not mortgage, pledge, charge, sub-let, sell, lease, offer for sale, lend or otherwise deal with the Products or any interest in it or this Agreement without Our prior written consent.</p>
                      <p style={{ marginBottom: "3px" }}>3.8&nbsp;&nbsp;You will at all times, at Your own cost, maintain in full force and effect all permissions, certificates, licences, registrations, permits and authorisations required by any statutory authority in connection with the Products and/or their use and/or the Location in which the Products are kept and if the Products comprise vehicles You will at all times ensure that each vehicle is validly licensed, has a current Department of Transport Test Certificate and complies with all other requirements as to inspection, testing, plating, insurance and otherwise as for the time being required by law.</p>
                      <p style={{ marginBottom: "3px" }}>3.9&nbsp;&nbsp;If the Products is/are a vehicle to which the Goods Vehicles (Licensing of Operators) Act 1995 applies, then You must ensure that any operator of the Products, including any person to whom with Our consent You sub-let the Products possesses a valid operators' licence for the Products. We may request to see evidence of this licence at any time during the term of this Agreement.</p>
                      <p style={{ marginBottom: "3px" }}>3.10&nbsp;&nbsp;If the Products is/are a vehicle You will pay any charges, fines or other fixed penalties relating to the vehicle(s) immediately. If You fail to do so We may pay the amount of the charge, fine or penalty on Your behalf. You will then repay that amount to Us on demand together with such sums as We consider reasonable to cover Our administration costs connected with the charge, fine or fixed penalty.</p>
                    </div>

                  </div>
                </div>
                 <div style={{ height:'180px' }} />
                  <div className="w-full">
                    <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                      HEUD1024 | Page 5
                    </p>
                  </div>
              </div>

              {/* ── T&C PAGE 2: Sections 4, 5, 6 ── */}
              <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>
                <div style={{ border: "1px solid #9ca3af" }}>
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                    TERMS AND CONDITIONS
                  </div>
                  <div style={{ padding: "6px 8px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>

                    {/* Column 1 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>4.&nbsp;&nbsp;INSURANCE</div>
                      <p style={{ marginBottom: "3px" }}>4.1&nbsp;&nbsp;You must at all times keep the Products insured under a comprehensive policy without restriction or excess, for an amount equal to its replacement value, and You must note on the policy that the Products are Ours. You must show Us evidence of the policy, and if You fail to provide such evidence within 30 days of the date of this Agreement, We may at Our option arrange for the Products to be protected by Our own insurance policy at Your expense and collect a charge for this with each Rental. You will have no contractual rights, direct or indirect, under that insurance policy.</p>
                      <p style={{ marginBottom: "3px" }}>4.2&nbsp;&nbsp;If the Products are lost or an insurance claim has to be made, You must notify Us immediately. If a claim is made We will use any proceeds received by Us to replace or repair the Products or as We may otherwise decide is appropriate in the circumstances. Any replacement products provided under Your insurance policy or under Our insurance policy will belong to Us.</p>
                      <p style={{ marginBottom: "3px" }}>4.3&nbsp;&nbsp;If there is a total loss of the Products for insurance purposes, We may terminate the hiring of the Products and You will pay to Us the amounts set out in Clause 8.</p>
                      <p style={{ marginBottom: "6px" }}>4.4&nbsp;&nbsp;Any insurance monies received by You will be held by You on trust for Us and will constitute trust monies.</p>

                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>5.&nbsp;&nbsp;THE SUPPLIER AND MAINTENANCE</div>
                      <p style={{ marginBottom: "3px" }}>5.1&nbsp;&nbsp;If it is indicated that maintenance charges are a part of the Rental then We will act as the Supplier's agent to collect the sums from You. You must enter a maintenance contract for the Products and that contract must continue for the same period as this Agreement. You must perform Your obligations under that contract. The Supplier will be solely responsible for the maintenance and We are not responsible for any failure by the Supplier to provide it.</p>
                      <p style={{ marginBottom: "3px" }}>5.2&nbsp;&nbsp;We may increase the Rentals by the amount of the increase in the maintenance charges due to the Supplier if the maintenance contract allows for that, and We are so requested by the Supplier.</p>
                      <p style={{ marginBottom: "3px" }}>5.3&nbsp;&nbsp;We shall be entitled to apply amounts received from You first towards satisfaction of the Rental, excluding any maintenance charges, notwithstanding appropriation to the contrary. If You do not pay the full Rental amount We will stop paying the maintenance charges to the Supplier, who may stop providing maintenance. This does not affect any of Your obligations to Us under this Agreement.</p>
                      <p style={{ marginBottom: "3px" }}>5.4&nbsp;&nbsp;If this Agreement is terminated the Supplier may bring an action to recover any maintenance charges that are due from You under the maintenance contract.</p>
                      <p style={{ marginBottom: "6px" }}>5.5&nbsp;&nbsp;Should the Supplier become unable to provide the maintenance You may by at least one month's written notice tell Us to stop paying the maintenance charges to the Supplier and We will reduce the Rentals by the amount of the maintenance charges from the next Rental payment date. Even if You stop the maintenance charges You may still have obligations to the Supplier.</p>
                    </div>

                    {/* Column 2 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>6.&nbsp;&nbsp;YOUR ACKNOWLEDGEMENTS</div>
                      <p style={{ marginBottom: "3px" }}>6.1&nbsp;&nbsp;You and We recognise that there is a risk that any products, in particular computer hardware and software may not perform as expected and may not be satisfactory. We both also acknowledge that salespeople acting on behalf of suppliers may make representations about products including computer hardware and software that are difficult to evaluate until delivery and commissioning. When products are financed the risk of them not working satisfactorily or according to any representations may be assumed by You, by Us, by the supplier, by an intermediary or by an insurer. You and We both appreciate that the allocation of risk is a matter of agreement and You and We have decided that it shall be borne by You.</p>
                      <p style={{ marginBottom: "3px" }}>6.2&nbsp;&nbsp;For that reason, You and We agree that there is no term in this Agreement by which We are responsible for the performance of the Products, whether generally or in relation to any particular purpose. We do not know if any representation was made to You about the Products, but if it was, You acknowledge that it was not made on Our behalf and that You have not entered into this Agreement in reliance on it. You and We also agree that We have not assumed any duty of care towards You.</p>
                      <p style={{ marginBottom: "3px" }}>6.3&nbsp;&nbsp;You represent and warrant that You have obtained from the Supplier of the Products all representations, warranties and guarantees You require in relation to the Products including but not limited to its quality, fitness for purpose and description.</p>
                      <p style={{ marginBottom: "3px" }}>6.4&nbsp;&nbsp;To the extent permitted by law, You and We agree that no terms are to be implied into this Agreement.</p>
                      <p style={{ marginBottom: "3px" }}>6.5&nbsp;&nbsp;If the law requires terms to be implied into this Agreement, You and We agree that We are not liable for any breach of them, because if the risk of breach of any such terms had been allocated differently We would have charged a higher rental because We are not in a position to evaluate and therefore insure against the risk of a breach, whilst You are in a better position to do so, because You have chosen the Products and the Supplier.</p>
                      <p style={{ marginBottom: "3px" }}>6.6&nbsp;&nbsp;In no event will Our liability under this Agreement exceed the aggregate of the Rentals paid by You at the time the liability arises.</p>
                      <p style={{ marginBottom: "3px" }}>6.7&nbsp;&nbsp;In no event will We be liable to You in contract, tort or otherwise including any liability for negligence: (a) for any loss of revenue business, Anticipated Savings or profits or any loss of use or value; or (b) for any indirect or consequential loss; however arising. 'Anticipated Savings' means any expenses which You expect to avoid incurring or to incur in a lesser amount than would otherwise have been the case.</p>
                      <p style={{ marginBottom: "6px" }}>6.8&nbsp;&nbsp;The Supplier is not Our agent to make any statements concerning this Agreement or the Products.</p>

                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>7.&nbsp;&nbsp;TERMINATION OF THE AGREEMENT</div>
                      <p style={{ marginBottom: "3px" }}>7.1&nbsp;&nbsp;We shall be entitled to treat any breach by You of any of Your obligations under this Agreement as a repudiatory breach indicating You no longer intend to abide by this Agreement which We may accept, and We may subject to giving You any notice required by law, terminate the hiring hereunder. Without prejudice to the generality of the foregoing, We may subject to giving You any notice required by law, terminate the hiring of the Products under this Agreement if:-</p>
                      <p style={{ marginBottom: "3px" }}>a)&nbsp;&nbsp;You do not pay any Rentals or other sums due under this Agreement on the due dates for payment;</p>
                      <p style={{ marginBottom: "3px" }}>b)&nbsp;&nbsp;You breach any term of this Agreement and if such breach is remediable You fail to remedy it within 7 days of written notice requiring its remedy;</p>
                      <p style={{ marginBottom: "3px" }}>c)&nbsp;&nbsp;(if You are a partnership) any of the partners dies, a petition is presented for an administration order to be made in relation to, or a resolution is passed for the winding up or dissolution of the partnership or a petition is presented for a bankruptcy order to be made against one or more of the partners for non-payment of a partnership debt or any one or more of the partners enters into a voluntary arrangement with the creditor of the partnership or the partnership enters into a voluntary arrangement with its creditors;</p>
                      <p style={{ marginBottom: "3px" }}>d)&nbsp;&nbsp;(if You are an individual) You die or an application is made for an interim order to be made in relation to You or a petition is presented for a bankruptcy order against You or a trustee in bankruptcy or like officer is appointed over all or any of Your assets or any other steps are taken to appoint an administrator.</p>
                    </div>

                  </div>
                </div>
                 <div style={{ height:'180px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 6
                </p>
              </div>
              </div>

              {/* ── T&C PAGE 3: Sections 7 cont., 8, 9, 10 ── */}
              <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>
                <div style={{ border: "1px solid #9ca3af" }}>
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                    TERMS AND CONDITIONS
                  </div>
                  <div style={{ padding: "6px 8px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>

                    {/* Column 1 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <p style={{ marginBottom: "3px" }}>e)&nbsp;&nbsp;an order is made for the appointment of an administrator over You or documents are filed for the appointment of an administrator over You or a notice of intention is presented to You or any other steps are taken to appoint an administrator;</p>
                      <p style={{ marginBottom: "3px" }}>f)&nbsp;&nbsp;You arrange or attempt to arrange a composition or scheme with Your creditors or a meeting of creditors is called;</p>
                      <p style={{ marginBottom: "3px" }}>g)&nbsp;&nbsp;You cease or threaten to cease to carry on trading or sell or dispose of a substantial part of Your business or assets without Our consent or there is an adverse change to Your business;</p>
                      <p style={{ marginBottom: "3px" }}>h)&nbsp;&nbsp;there is any change in Your control (whether direct or indirect) or Your present holding company ceases to be Your legal and beneficial owner (free from all mortgages, charges, liens or other encumbrances) of the whole or any part of Your issued share capital from time to time;</p>
                      <p style={{ marginBottom: "3px" }}>i)&nbsp;&nbsp;You are unable to pay Your debts as they fall due (as defined by section 123 or 268 of the Insolvency Act 1986);</p>
                      <p style={{ marginBottom: "3px" }}>j)&nbsp;&nbsp;(in Scotland) You become a bankrupt or have Your estate sequestrated or execute a trust deed, or a judicial factor is appointed to administer Your estate;</p>
                      <p style={{ marginBottom: "3px" }}>k)&nbsp;&nbsp;any distress execution or other legal process is levied against any of Your assets or an encumbrancer takes possession of any of Your assets, or any security created by You becomes enforceable and the mortgagee or chargee takes steps to enforce the same;</p>
                      <p style={{ marginBottom: "3px" }}>l)&nbsp;&nbsp;any guarantee in respect of Your obligations under this Agreement is not or ceases to be fully valid binding and enforceable;</p>
                      <p style={{ marginBottom: "3px" }}>m)&nbsp;&nbsp;any representation made or information provided by You or on Your behalf to Us from time to time in connection with the negotiation or continuation of this Agreement is found to be incorrect as to a particular which, in Our opinion, is material;</p>
                      <p style={{ marginBottom: "3px" }}>n)&nbsp;&nbsp;In Our sole opinion, We have reasonable grounds to believe the Products, or Our interest in it/them, is/are at risk;</p>
                      <p style={{ marginBottom: "3px" }}>o)&nbsp;&nbsp;Any steps are taken to appoint an administrator or administrative receiver in respect of You or to appoint a receiver over any of Your assets;</p>
                      <p style={{ marginBottom: "3px" }}>p)&nbsp;&nbsp;You are liquidated or wound up or have a petition for winding up presented against You or You pass a resolution for voluntary winding up (otherwise than in the course of a restructuring approved in writing by Us in advance);</p>
                      <p style={{ marginBottom: "3px" }}>q)&nbsp;&nbsp;You fail to comply with the terms of any other finance agreement that You are party to and that failure entitles any other party to the agreement the right to terminate it or accelerate any payments payable by You under it;</p>
                      <p style={{ marginBottom: "6px" }}>r)&nbsp;&nbsp;You or any of Your directors, officers or employees are convicted of or involved in any offence under legislation relating to money laundering and/or acts of terrorism, or fail to comply with any such legislation.</p>

                      <p style={{ marginBottom: "6px" }}>7.2&nbsp;&nbsp;You are aware that We do not support or participate in business in jurisdictions that are the subject of embargoes, sanctions or similar measures. You confirm that You have no offices, investments, activities or planned activities in countries or regions which are the subject of sanctions, embargoes or similar measures imposed by any of the US OFAC, the EU, the UK government or any other relevant sanctions authority. In the event that You have offices, investments, activities or planned activities in countries or regions which are subject to such sanctions, embargoes or similar measures, You will immediately notify Us and We shall have the right to terminate this Agreement on written notice to You with immediate effect.</p>
                    </div>

                    {/* Column 2 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>8.&nbsp;&nbsp;YOUR OBLIGATIONS ON TERMINATION</div>
                      <p style={{ marginBottom: "3px" }}>Upon any termination of this Agreement and/or the hiring of the Products for any reason</p>
                      <p style={{ marginBottom: "3px" }}>8.1&nbsp;&nbsp;You must :</p>
                      <p style={{ marginBottom: "3px" }}>a)&nbsp;&nbsp;pay to Us immediately a sum equal to all arrears of Rentals and other payments and interest;</p>
                      <p style={{ marginBottom: "3px" }}>b) pay to Us as agreed damages and/or a debt a sum equal to all the Rentals (less any maintenance payments) that You would have paid had the Agreement continued for the Minimum Period less a discount from the date of termination to the date the Rental would otherwise have fallen due at a rate of 2% per annum; and</p>
                      <p style={{ marginBottom: "3px" }}>c)&nbsp;&nbsp;pay as agreed damages and/or a debt all Our costs in repossessing, repairing and selling the Products and administration of the termination including legal fees, all on a full indemnity basis.</p>
                      <p style={{ marginBottom: "3px" }}>8.2&nbsp;&nbsp;Our consent for You to possess the Products is withdrawn.</p>
                      <p style={{ marginBottom: "6px" }}>8.3&nbsp;&nbsp;Strictly subject to Us recovering possession of the Products and/or You fully complying with Your obligations under Clause 9.2, and to the Products being sold by Us, We will apply any net proceeds of sale of the Products (excluding VAT and any costs of repossession, insurance, storage and sale and legal costs), in diminution or extinguishment of the termination sum calculated under Clause 8.1 above. If any surplus remains following application of the net proceeds of sale to the termination sum, such surplus shall be legally and beneficially Ours in its entirety.</p>

                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>9.&nbsp;&nbsp;INSPECTION AND RETURN OF PRODUCTS</div>
                      <p style={{ marginBottom: "3px" }}>9.1&nbsp;&nbsp;You must let Us and Our representatives inspect the Products upon Us giving You 48 hours' notice of our intention to do so. Immediately upon termination of the hiring of the Products under this Agreement, or upon termination of the Agreement, Our consent for You to possess the Products is withdrawn. Upon the termination or expiry of the hiring of the Products or termination of the Agreement We or Our representatives may, subject to giving You any notice required by law, repossess the Products and, (if required by law) under an order of the Court or with Your consent given at that time, enter the Location and or any premises where the Products are or are believed to be located.</p>
                      <p style={{ marginBottom: "6px" }}>9.2&nbsp;&nbsp;When this Agreement expires, or is terminated, You must immediately return the Products to an address nominated by Us within the United Kingdom. The Products must be properly packed for shipment in accordance with the manufacturer's recommendations and specifications, freight prepaid and insured. If You fail to do so You will be liable for Our costs in recovering the Products and/or restoring them to Average Saleable Condition. Average Saleable Condition means that all of the Products are immediately available for use by a third party, other than Yourself, in good working order and condition, free from any defects and without the need for repair or refurbishment, fair wear and tear excluded. All Products must be free of markings. You will pay Us on demand for any damage, missing or defective parts of accessories. If all or part of the Products consist of computer equipment You must remove all personal data, sensitive data and passwords. Upon expiry or termination of this Agreement and/or hiring the Products for any reason then, notwithstanding the other terms of this clause, if You do not or cannot return the Products to Us for any reason within 30 days of such expiry or termination, including but without limitation because they are a total loss, then You will pay Us forthwith a sum equal to the amount We anticipated the Products would be worth at the end of the Minimum Period assuming it had been returned in Average Saleable Condition.</p>

                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>10.&nbsp;&nbsp;YOUR RIGHTS TO END THE AGREEMENT</div>
                      <p style={{ marginBottom: "3px" }}>10.1&nbsp;&nbsp;You may apply to Us to terminate the hiring of the Products during the Minimum Period by giving Us at least 90 days written notice. If We accept Your request, You must pay Us a sum calculated in accordance with Clause 8.</p>
                      <p style={{ marginBottom: "3px" }}>10.2&nbsp;&nbsp;On termination under Clause 10.1 You must also comply with Your obligations in Clause 9.2.</p>
                    </div>

                  </div>
                </div>
                 <div style={{ height:'180px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 7
                </p>
              </div>
              </div>

              {/* ── T&C PAGE 4: Sections 11, 12 ── */}
              <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>
                <div style={{ border: "1px solid #9ca3af" }}>
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                    TERMS AND CONDITIONS
                  </div>
                  <div style={{ padding: "6px 8px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>

                    {/* Column 1 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>11.&nbsp;&nbsp;GENERAL</div>
                      <p style={{ marginBottom: "3px" }}>11.1&nbsp;&nbsp;We may assign this Agreement and/or deal in Our rights and the Products, but this Agreement is personal to You and You may not do that.</p>
                      <p style={{ marginBottom: "3px" }}>11.2&nbsp;&nbsp;If We give You any relaxing of Our rights this does not affect Our ability to enforce Our rights to their full extent.</p>
                      <p style={{ marginBottom: "3px" }}>11.3&nbsp;&nbsp;Any notice to be sent to You will be sent to the address shown or Your last known address and deemed delivered two working days after posting.</p>
                      <p style={{ marginBottom: "3px" }}>11.4&nbsp;&nbsp;If any clause of this Agreement is invalid, that will not affect the validity of others.</p>
                      <p style={{ marginBottom: "3px" }}>11.5&nbsp;&nbsp;Value Added Tax at the applicable rate will be paid by You on all appropriate payments.</p>
                      <p style={{ marginBottom: "3px" }}>11.6&nbsp;&nbsp;You will pay Our costs and charges for dealing with unpaid, returned or recalled payments or direct debits, for providing You with other services that You request, and enforcing the terms of this Agreement and repossessing and selling the Products on a full indemnity basis.</p>
                      <p style={{ marginBottom: "3px" }}>11.7&nbsp;&nbsp;No person has any rights under this Agreement save as may be set out in it and the parties agree that the Contracts (Rights of Third Parties) Act 1999 is excluded.</p>
                      <p style={{ marginBottom: "3px" }}>11.8&nbsp;&nbsp;In this Agreement references to "You" and "Your" are to the Hirer and if the Hirer is two or more people each of them jointly and separately. The words with capital letters refer to the description in the Agreement. "Group Member" means any company.</p>
                      <p style={{ marginBottom: "3px" }}>11.9&nbsp;&nbsp;If You are more than one person, Your obligations will be binding on each person separately and all persons jointly.</p>
                      <p style={{ marginBottom: "6px" }}>11.10&nbsp;&nbsp;English law governs this Agreement. The Courts of England and Wales shall have exclusive Jurisdiction in connection with the Agreement.</p>
                      <p style={{ marginBottom: "6px" }}>11.11&nbsp;&nbsp;No person, including any manufacturer or supplier of the Goods, who introduced You to Us or who negotiated this Agreement acted as Our agent and is not Our partner, employee, or associate. If You are introduced to Us by a broker or a third party (Introducer), a commission may have been paid or may be paid by Us to the Introducer in relation to that introduction. If You require more information about the commission We have paid (or may pay), You shall contact the Introducer. If for any reason You cannot get this information from the Introducer, You shall contact Us and We will provide the information to You. By signing this Agreement, You consent to Us paying a commission to an Introducer.</p>
                    </div>

                    {/* Column 2 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "3px" }}>12.&nbsp;&nbsp;COMPLAINTS</div>
                      <p style={{ marginBottom: "3px" }}>12.1&nbsp;&nbsp;Should You have a complaint about Our financial product, You will be advised of contact details once Your Finance company has been chosen. Details will be provided within Your acceptance letter upon inception of this Agreement. In some circumstances, if You are an eligible complainant, You may be able to refer the matter to the Financial Ombudsman Service. Details are available from Us on request or from www.financial-ombudsman.org.uk - The Financial Ombudsman Service, Exchange Tower, London E14 9SR.</p>
                    </div>

                  </div>
                </div>
                 <div style={{ height:'380px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 8
                </p>
              </div>
              </div>

               {/* ── USE OF PERSONAL DATA STATEMENT ── */}
              <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>
                <div style={{ border: "1px solid #9ca3af" }}>
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                    USE OF PERSONAL DATA STATEMENT
                  </div>

                  <div style={{ padding: "6px 8px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>

                    {/* Column 1 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify", color: "#374151" }}>
                      <p style={{ marginBottom: "4px" }}>
                        This Use of Personal Data Statement ('Statement') describes how the finance company whose details appear at the beginning of this document ('we', 'us', 'our') collects and processes personal information about you; how this information is used and protected, and your rights in relation to this information. Further details of how we use and protect your personal data are available on request.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>PERSONAL INFORMATION WE USE</p>
                      <p style={{ marginBottom: "4px" }}>
                        We may be required to collect certain personal information about you by law or as a consequence of the business relationship we have with you. Failure to provide this information may prevent or delay the fulfilment of these obligations.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>INFORMATION WE COLLECT DIRECTLY FROM YOU</p>
                      <p style={{ marginBottom: "4px" }}>
                        Categories of information that we may collect directly from you include your personal details (e.g., name and date of birth), contact details, transaction information and information about your associated persons, such as your spouse, partner, any directors of your company, or other persons with whom you are financially linked ('associated persons'). If you are providing us with personal information about your associated persons, please provide a copy of this Statement to them.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>INFORMATION WE COLLECT FROM CREDIT REFERENCE AGENCIES AND FRAUD PREVENTION AGENCIES</p>
                      <p style={{ marginBottom: "4px" }}>
                        We also collect personal information about you and your associated persons from credit reference agencies and fraud prevention agencies. We will search your records (and those of your associated persons) with credit reference agencies and fraud prevention agencies when we receive your application, whether or not the application proceeds. We will also make periodic searches of your records during the life of our contractual relationship with you.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>HOW WE USE YOUR PERSONAL INFORMATION AND THE BASIS ON WHICH WE USE IT</p>
                      <p style={{ marginBottom: "3px" }}>We may use your personal information for the following purposes:</p>
                      <p style={{ marginBottom: "3px", paddingLeft: "8px" }}>
                        <span style={{ fontWeight: "600" }}>•</span>&nbsp;&nbsp;Credit reference and fraud prevention checks: we process your personal information to carry out credit reference checks and for fraud prevention purposes. The personal information we have collected from you will be shared with fraud prevention agencies who will use it to prevent fraud and money-laundering and to verify your identity. If fraud is detected, you could be refused certain services, finance or employment. Further details of how your information will be used by us and these fraud prevention agencies, and your data protection rights, can be found in the Credit Reference Agency Information Notice available here http://www.experian.co.uk/crain/index.html or by contacting us at the details below.
                      </p>
                      <p style={{ marginBottom: "3px", paddingLeft: "8px" }}>
                        <span style={{ fontWeight: "600" }}>•</span>&nbsp;&nbsp;Identification and authentication and administering the services: we use your identification information to verify your identity when you access and use our services and to ensure the security of your personal information. We also process your personal information to administer the finance, services and products you have requested. We use your personal information for these purposes so that we can comply with our contractual obligations to you.
                      </p>
                      <p style={{ marginBottom: "3px", paddingLeft: "8px" }}>
                        <span style={{ fontWeight: "600" }}>•</span>&nbsp;&nbsp;Improving our services and marketing analysis: we analyse information about how you use our services to provide an improved experience for all our customers. We also
                            carry out marketing analysis and customer profiling (including with transactional information) and conduct research, including creating statistical and testing information. It
                            is in our legitimate business interests to use the information provided to us for this purpose, so we can understand your needs and identify any issues with our services to
                            improve them.
                      </p>
                      <p style={{ marginBottom: "3px", paddingLeft: "8px" }}>
                        <span style={{ fontWeight: "600" }}>•</span>&nbsp;&nbsp;Communicating with you: we may use any categories of your personal information when we communicate with you. It is in our legitimate interests that we are able to provide you with appropriate responses and provide you with notice about our services.
                      </p>
                      <p style={{ marginBottom: "3px", paddingLeft: "8px" }}>
                        <span style={{ fontWeight: "600" }}>•</span>&nbsp;&nbsp;Exercising our rights: we may use any categories of your personal information to exercise our legal rights where it is necessary to do so, for example to detect, prevent and respond to fraud claims, intellectual property infringement claims or violations of law or the contract. This includes allowing our insurance management contractor(s) to contact you to establish if you have obtained the insurance cover required by your contractual obligations to us.
                      </p>
                    </div>

                    {/* Column 2 */}
                    <div style={{ lineHeight: "1.5", textAlign: "justify", color: "#374151" }}>
                      <p style={{ fontWeight: "600", marginBottom: "2px" }}>YOUR RIGHTS OVER YOUR PERSONAL INFORMATION</p>
                      <p style={{ marginBottom: "4px" }}>
                        We encourage you to contact us to update or correct your information if it changes or if the personal information we hold about you is inaccurate. You may also have certain rights regarding your personal information. These include the right to access, rectify, erase or port your personal information. You may also have the right to restrict or object to our use of your personal information and to withdraw any consents you have provided us. You also have the right to lodge a complaint with your local data protection authority. If you would like to discuss or exercise such rights, please contact us.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>CREDIT DECISIONS</p>
                      <p style={{ marginBottom: "4px" }}>
                        In order to determine whether to accept your application for credit, we will analyse your financial history, credit reference records and other relevant information about you (or your associated persons) collected from you and credit reference and fraud prevention agencies. We use this information because it helps us to determine your creditworthiness and suitability for entering into contracts with you.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>INFORMATION SHARING</p>
                      <p style={{ marginBottom: "4px" }}>
                        We may share personal information relating to you and your associated persons with credit reference agencies and fraud prevention agencies to help us and other organisations make decisions on motor, household, credit, life and other insurance proposals and insurance claims, for you and your associated persons, managing credit and credit related accounts or facilities and checking details of job applicants and employees. You have a legal right to obtain details of the credit reference and fraud prevention agencies from whom we obtain and to whom we pass information about you. You also have a right to further details explaining how the information held by fraud prevention agencies may be used. If you would like to obtain such information, please contact us. We may also share your personal information with our suppliers and service providers, our group companies, joint venture partners, law enforcement agencies, court, regulators or government authorities, insurers and third party asset purchasers under certain circumstances.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>STORAGE</p>
                      <p style={{ marginBottom: "4px" }}>
                        We will keep your personal information for as long as we have a relationship with you. After our relationship with you has ended, we will take into account our legal obligations and regulators' expectations when deciding how long to keep your personal information. We may also retain records to investigate or defend potential legal claims.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>INTERNATIONAL DATA TRANSFER</p>
                      <p style={{ marginBottom: "4px" }}>
                        Your personal information may be transferred to, stored and processed in a country that is not regarded as ensuring an adequate level of protection for personal information under European Union and English law. We have put in place appropriate safeguards (such as contractual commitments) in accordance with applicable legal requirements to ensure that your data is adequately protected. Please contact us if you require more information on the appropriate safeguards in place.
                      </p>

                      <p style={{ fontWeight: "600", marginBottom: "2px", marginTop: "4px" }}>CONTACT US</p>
                      <p style={{ marginBottom: "4px" }}>
                        If you have questions or concerns regarding the way in which your personal information has been used, please contact us. Our contact details are included at the beginning of our contract with you and in our website.
                      </p>
                    </div>

                  </div>
                </div>
                 <div style={{ height:'180px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 9
                </p>
              </div>
              </div>

              <div className="page-break-after">
              {/* ---  The Direct Debit Guarantee--- */}

              <div className="border border-gray-400 p-4 space-y-4">
                {/* Header */}
                <div className=" text-black font-bold text-center py-1">
                  The Direct Debit Guarantee
                </div>

                <div className="text-gray-700 text-xs space-y-2">
                  <p>
                    This Guarantee is offered by all banks and building
                    societies that accept instructions to pay Direct Debits.
                  </p>
                  <ul className="list-disc list-inside space-y-1">
                    <li>
                      If there are any changes to the amount, date or frequency
                      of Your Direct Debit the Owner will notify You within 5
                      working days in advance of Your account being debited or
                      as otherwise agreed.
                    </li>
                    <li>
                      If You request the Owner to collect a payment,
                      confirmation of the amount and date will be given to You
                      at the time of the request.
                    </li>
                    <li>
                      If an error is made in the payment of Your Direct Debit by
                      the Owner or your bank or building society, You are
                      entitled to a full and immediate refund of the amount paid
                      from Your bank or building society.
                    </li>
                    <li>
                      If You receive a refund You are not entitled to, You must
                      pay it back when the Owner asks You to.
                    </li>
                    <li>
                      You can cancel a Direct Debit at any time by simply
                      contacting Your bank or building society. Written
                      confirmation may be required. Please also notify Us.
                    </li>
                  </ul>
                </div>

                {/* Header */}
                {/* ── DIRECT DEBIT ── */}
                <div  style={{ fontSize: "8px", padding: "16px 24px" }}>
                  <div style={{ background: "#eef2e8", border: "2px solid #2563eb", padding: "12px 16px" }}>

                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "10px" }}>
                      <div style={{ flex: 1, textAlign: "center" }}>
                        <div style={{ fontWeight: "bold", fontSize: "10px", marginBottom: "4px" }}>
                          INSTRUCTION TO YOUR BANK OR BUILDING SOCIETY TO PAY BY DIRECT DEBIT
                        </div>
                        <div style={{ fontSize: "8px" }}>Please complete this form and send it to the Originator.</div>
                      </div>
                      {/* Direct Debit Logo */}
                      <div style={{ marginLeft: "16px", display: "flex", flexDirection: "column", alignItems: "center", minWidth: "80px" }}>
                        <img
                          src="https://quoting-tool.fibretelecomsuk.co.uk/images/acceptance.png"
                          alt="Direct Debit"
                          style={{ width: "70px", height: "auto", objectFit: "contain" }}
                        />
                      </div>
                    </div>

                    {/* Two column layout */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>

                      {/* LEFT COLUMN */}
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

                        {/* Section 1 */}
                        <div>
                          <div style={{ fontWeight: "600", marginBottom: "6px" }}>
                            1. Name and full postal address of your Bank or Building Society Branch
                          </div>
                          <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <tbody>
                              <tr style={{ marginBottom: "3px" }}>
                                <td style={{ padding: "2px 0", whiteSpace: "nowrap", width: "110px", verticalAlign: "middle" }}>To the Manager</td>
                                <td style={{ padding: "2px 0 2px 4px" }}>
                                  {isPdfMode ? (
                                    <div style={{ border: "1px solid #9ca3af", padding: "1px 4px", background: "white", minHeight: "14px" }}>{formData.bankName || " "}</div>
                                  ) : (
                                    <input type="text" value={formData.bankName || ""}
                                      onChange={(e) => setFormData({ ...formData, bankName: e.target.value })}
                                      style={{ width: "100%", border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: "2px 0", whiteSpace: "nowrap", verticalAlign: "middle" }}>Bank/Building Society</td>
                                <td style={{ padding: "2px 0 2px 4px" }}>
                                  {isPdfMode ? (
                                    <div style={{ border: "1px solid #9ca3af", padding: "1px 4px", background: "white", minHeight: "14px" }}>{formData.building || " "}</div>
                                  ) : (
                                    <input type="text" value={formData.building || ""}
                                      onChange={(e) => setFormData({ ...formData, building: e.target.value })}
                                      style={{ width: "100%", border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: "2px 0", whiteSpace: "nowrap", verticalAlign: "middle" }}>Address</td>
                                <td style={{ padding: "2px 0 2px 4px" }}>
                                  {isPdfMode ? (
                                    <div style={{ border: "1px solid #9ca3af", padding: "1px 4px", background: "white", minHeight: "14px" }}>{formData.bankAddress || " "}</div>
                                  ) : (
                                    <input type="text" value={formData.bankAddress || ""}
                                      onChange={(e) => setFormData({ ...formData, bankAddress: e.target.value })}
                                      style={{ width: "100%", border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: "2px 0", whiteSpace: "nowrap", verticalAlign: "middle" }}>Postcode</td>
                                <td style={{ padding: "2px 0 2px 4px" }}>
                                  {isPdfMode ? (
                                    <div style={{ border: "1px solid #9ca3af", padding: "1px 4px", background: "white", minHeight: "14px", width: "80px" }}>{formData.bank_postcode || " "}</div>
                                  ) : (
                                    <input type="text" value={formData.bank_postcode || ""}
                                      onChange={(e) => setFormData({ ...formData, bank_postcode: e.target.value })}
                                      style={{ width: "80px", border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {/* Section 2 */}
                        <div>
                          <div style={{ fontWeight: "600", marginBottom: "4px" }}>2. Name(s) of Account Holder(s)</div>
                          {isPdfMode ? (
                            <div style={{ border: "1px solid #9ca3af", padding: "1px 4px", background: "white", minHeight: "14px" }}>{formData.companyName || " "}</div>
                          ) : (
                            <input type="text" value={formData.companyName || ""}
                              onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                              style={{ width: "100%", border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                          )}
                        </div>

                        {/* Section 3 - Sort Code */}
                        <div>
                          <div style={{ fontWeight: "600", marginBottom: "4px" }}>3. Branch Sort Code (from top right corner of the cheque)</div>
                          <div style={{ display: "flex", gap: "3px" }}>
                            {(formData.sortCode || ["", "", "", "", "", ""]).map((digit, index) => (
                              isPdfMode ? (
                                <div key={index} style={{ width: "22px", height: "22px", border: "2px solid #9ca3af", background: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "8px", fontFamily: "monospace" }}>
                                  {digit}
                                </div>
                              ) : (
                                <input key={index} type="text" value={digit} maxLength="2"
                                  onChange={(e) => handleSortCodeChange(index, e.target.value)}
                                  style={{ width: "22px", height: "22px", border: "2px solid #9ca3af", textAlign: "center", fontSize: "8px", fontFamily: "monospace", outline: "none", background: "white", padding: "0" }} />
                              )
                            ))}
                          </div>
                        </div>

                        {/* Section 4 - Account Number */}
                        <div>
                          <div style={{ fontWeight: "600", marginBottom: "4px" }}>4. Bank or Building Society Account Number</div>
                          <div style={{ display: "flex", gap: "3px" }}>
                            {(formData.accountNumber || ["", "", "", "", "", "", "", ""]).map((digit, index) => (
                              isPdfMode ? (
                                <div key={index} style={{ width: "22px", height: "22px", border: "2px solid #9ca3af", background: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "8px", fontFamily: "monospace" }}>
                                  {digit}
                                </div>
                              ) : (
                                <input key={index} type="text" value={digit} maxLength="1"
                                  onChange={(e) => handleAccountNumberChange(index, e.target.value)}
                                  style={{ width: "22px", height: "22px", border: "2px solid #9ca3af", textAlign: "center", fontSize: "8px", fontFamily: "monospace", outline: "none", background: "white", padding: "0" }} />
                              )
                            ))}
                          </div>
                        </div>

                      </div>

                      {/* RIGHT COLUMN */}
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

                        {/* Service User Number */}
                        <div>
                          <div style={{ fontWeight: "600", marginBottom: "4px" }}>Service User Number (6 digits)</div>
                          {isPdfMode ? (
                            <div style={{ border: "1px solid #9ca3af", padding: "1px 4px", background: "white", minHeight: "14px" }}>{formData.serviceUserNumber || " "}</div>
                          ) : (
                            <input type="text" value={formData.serviceUserNumber || ""}
                              onChange={(e) => setFormData({ ...formData, serviceUserNumber: e.target.value })}
                              style={{ width: "100%", border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                          )}
                        </div>

                        {/* Section 5 - Reference */}
                        <div>
                          <div style={{ fontWeight: "600", marginBottom: "4px" }}>5. Reference (originator reference number)</div>
                          {isPdfMode ? (
                            <div style={{ border: "1px solid #9ca3af", padding: "1px 4px", background: "white", minHeight: "14px" }}>{formData.reference || " "}</div>
                          ) : (
                            <input type="text" value={formData.reference || ""}
                              onChange={(e) => setFormData({ ...formData, reference: e.target.value })}
                              style={{ width: "100%", border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                          )}
                        </div>

                        {/* Section 6 - Instructions */}
                        <div style={{ border: "1px solid #9ca3af", background: "white", padding: "6px" }}>
                          <div style={{ fontWeight: "600", marginBottom: "3px" }}>6. Instruction to your Bank or Building Society:</div>
                          <p style={{ lineHeight: "1.5", textAlign: "justify" }}>
                            Please pay the Originator Direct Debits from the account detailed in this instruction subject to the safeguards assured by The Direct Debit Guarantee. I understand that this Instruction may remain with the Originator and, if so, details will be passed electronically to my Bank/ Building Society
                          </p>
                        </div>

                        {/* Signature */}
                        <div>
                          <div style={{ fontWeight: "600", marginBottom: "3px" }}>Signature(s)</div>
                          <div style={{ width: "100%", height: "50px", border: "1px dashed #9ca3af", background: "white", display: "flex", alignItems: "center", justifyContent: "center", color: "#9ca3af" }}>
                            {"{{Sig1_es_:signer1:signature}}"}
                          </div>
                        </div>

                        {/* Date */}
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
                          <span style={{ fontWeight: "600" }}>Date :</span>
                          {isPdfMode ? (
                            <div style={{ border: "1px solid #9ca3af", padding: "1px 6px", background: "white", minWidth: "70px" }}>{formData.date || " "}</div>
                          ) : (
                            <input type="date" value={formData.date || ""}
                              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                              style={{ border: "1px solid #9ca3af", padding: "1px 4px", fontSize: "8px", outline: "none", background: "white" }} />
                          )}
                        </div>

                      </div>
                    </div>
                    
                  </div>
                 
                </div>
                
              </div>
             <div style={{ height:'280px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 10
                </p>
              </div>
              
              </div>
             {/* ── SCHEDULE OF PRODUCTS ── */}
              <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>
                <div style={{ border: "1px solid #9ca3af" }}>

                  {/* Title */}
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0", borderBottom: "1px solid #9ca3af" }}>
                    SCHEDULE OF PRODUCTS
                  </div>

                  {/* REF NO */}
                  <div style={{ padding: "3px 6px", borderBottom: "1px solid #9ca3af" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span style={{ fontWeight: "600", whiteSpace: "nowrap" }}>REF.NO:</span>
                      <div style={{ flex: 1, border: "1px solid #9ca3af", padding: "1px 4px", minHeight: "16px" }}>
                        {isPdfMode ? (
                          <span>{formData.refNumber || " "}</span>
                        ) : (
                          <input type="text" value={formData.refNumber || ""}
                            onChange={(e) => setFormData({ ...formData, refNumber: e.target.value })}
                            style={{ width: "100%", border: "none", outline: "none", fontSize: "8px" }} />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* CUSTOMER Header */}
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0", borderBottom: "1px solid #9ca3af" }}>
                    CUSTOMER ("You", "Your", "Hirer")
                  </div>

                  {/* Customer Name row */}
                  <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                    <tbody>
                      <tr>
                        <td style={{ background: "#f3f4f6", padding: "2px 6px", fontWeight: "600", width: "130px", borderRight: "1px solid #9ca3af" }}>Customer's Name</td>
                        <td style={{ padding: "2px 6px" }}>
                          {isPdfMode ? (
                            <span>{formData.companyName || " "}</span>
                          ) : (
                            <input type="text" value={formData.companyName || ""}
                              onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                              style={{ width: "100%", border: "none", outline: "none", fontSize: "8px" }} />
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Address + Postcode row */}
                  <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                    <tbody>
                      <tr>
                        <td style={{ background: "#f3f4f6", padding: "2px 6px", fontWeight: "600", width: "130px", borderRight: "1px solid #9ca3af" }}>Registered Address</td>
                        <td style={{ padding: "2px 6px", borderRight: "1px solid #9ca3af" }}>
                          {isPdfMode ? (
                            <span>{formData.fullAddress || " "}</span>
                          ) : (
                            <input type="text" value={formData.fullAddress || ""}
                              onChange={(e) => setFormData({ ...formData, fullAddress: e.target.value })}
                              style={{ width: "100%", border: "none", outline: "none", fontSize: "8px" }} />
                          )}
                        </td>
                        <td style={{ background: "#f3f4f6", padding: "2px 6px", fontWeight: "600", width: "80px", borderRight: "1px solid #9ca3af", textAlign: "center" }}>Reg. Postcode</td>
                        <td style={{ padding: "2px 6px", width: "100px" }}>
                          {isPdfMode ? (
                            <span>{formData.postcode || " "}</span>
                          ) : (
                            <input type="text" value={formData.postcode || ""}
                              onChange={(e) => setFormData({ ...formData, postcode: e.target.value })}
                              style={{ width: "100%", border: "none", outline: "none", fontSize: "8px" }} />
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* DETAILS OF PRODUCTS Header */}
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0", borderBottom: "1px solid #9ca3af" }}>
                    DETAILS OF PRODUCTS
                  </div>

                  {/* Products body */}
                  <div style={{ padding: "3px 6px", borderBottom: "1px solid #9ca3af" }}>
                    <div style={{ fontStyle: "italic", marginBottom: "3px" }}>All products below are new unless otherwise stated.</div>
                    <div style={{ border: "1px solid #9ca3af", height: "200px", padding: "3px" }}>
                      {isPdfMode ? (
                        <div style={{ whiteSpace: "pre-wrap", height: "100%" }}>{formData.productsDetails || " "}</div>
                      ) : (
                        <textarea
                          value={formData.productsDetails || ""}
                          onChange={(e) => setFormData({ ...formData, productsDetails: e.target.value })}
                          style={{ width: "100%", height: "100%", border: "none", outline: "none", resize: "none", fontSize: "8px", boxSizing: "border-box" }}
                        />
                      )}
                    </div>
                  </div>

                  {/* SIGNATURE OF HIRER */}
                  <div style={{ border: "1px solid #9ca3af", margin: "4px 0 0 0" }}>
                    <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0", borderBottom: "1px solid #9ca3af" }}>
                      SIGNATURE OF HIRER
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%", verticalAlign: "middle" }}>Authorised Signatory</td>
                          <td style={{ padding: "3px 6px", width: "30%", height: "50px", border: "1px solid #d1d5db", background: "white", verticalAlign: "middle" }}>
                            <div style={{ width: "100%", height: "44px", border: "1px dashed #d1d5db", display: "flex", alignItems: "center", justifyContent: "center", color: "#9ca3af", background: "white" }}>
                            
                            </div>
                          </td>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%", verticalAlign: "middle" }}>Print Name</td>
                          <td style={{ padding: "3px 6px", width: "30%", verticalAlign: "middle" }}>{formData.managerName || " "}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>Position</td>
                          <td style={{ padding: "3px 6px", width: "30%" }}>{formData.position || " "}</td>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>Date</td>
                          <td style={{ padding: "3px 6px", width: "30%" }}>{formData.date || " "}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* FOR INTERNAL USE ONLY */}
                  <div style={{ textAlign: "center", fontWeight: "600", fontStyle: "italic", textDecoration: "underline", margin: "6px 0 3px 0" }}>
                    For Internal Use Only
                  </div>

                  {/* DUPLICATE SIGNATURE OF HIRER */}
                  <div style={{ border: "1px solid #9ca3af" }}>
                    <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0", borderBottom: "1px solid #9ca3af" }}>
                      SIGNATURE OF HIRER
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%", verticalAlign: "middle" }}>Authorised Signatory</td>
                          <td style={{ padding: "3px 6px", width: "30%", height: "50px", border: "1px solid #d1d5db", background: "white", verticalAlign: "middle" }}>
                            <div style={{ width: "100%", height: "44px", border: "1px dashed #d1d5db", display: "flex", alignItems: "center", justifyContent: "center", color: "#9ca3af", background: "white" }}>
                              
                            </div>
                          </td>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%", verticalAlign: "middle" }}>Print Name</td>
                          <td style={{ padding: "3px 6px", width: "30%", verticalAlign: "middle" }}>{formData.managerName || " "}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>Position</td>
                          <td style={{ padding: "3px 6px", width: "30%" }}>{formData.position || " "}</td>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>Date</td>
                          <td style={{ padding: "3px 6px", width: "30%" }}>{formData.date || " "}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                 <div style={{ height:'280px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 11
                </p>
              </div>
              </div>

              {/* ── ACCEPTANCE LETTER ── */}
              <div className="page-break-after" style={{ fontSize: "8px", padding: "16px 24px" }}>
                <div style={{ border: "1px solid #9ca3af" }}>
                  <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "3px 0" }}>
                    ACCEPTANCE LETTER
                  </div>

                  {/* Inner border box */}
                  <div style={{ border: "1px solid #9ca3af", margin: "6px" }}>
                    <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0", borderBottom: "1px solid #9ca3af" }}>
                      SIGNATURE OF HIRER
                    </div>

                    {/* TO row */}
                    <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>TO</td>
                          <td style={{ padding: "3px 6px", textAlign: "center", width: "60%" }}>
                            {isPdfMode ? (
                              <span>{formData.owner || " "}</span>
                            ) : (
                              <input type="text" value={formData.owner || ""}
                                onChange={(e) => setFormData({ ...formData, owner: e.target.value })}
                                placeholder="Enter owner name"
                                style={{ width: "100%", border: "none", outline: "none", background: "transparent", textAlign: "center", fontSize: "8px" }} />
                            )}
                          </td>
                          <td style={{ padding: "3px 6px", textAlign: "right", width: "20%" }}>("Owner")</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* RE HIRE AGREEMENT NO row */}
                    <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "40%" }}>RE HIRE AGREEMENT NO:</td>
                          <td style={{ padding: "3px 6px" }}>
                            {isPdfMode ? (
                              <span>{formData.agreementNumber || " "}</span>
                            ) : (
                              <input type="text" value={formData.agreementNumber || ""}
                                onChange={(e) => setFormData({ ...formData, agreementNumber: e.target.value })}
                                placeholder="Enter agreement number"
                                style={{ width: "100%", border: "none", outline: "none", background: "transparent", fontSize: "8px" }} />
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* BETWEEN THE OWNER AND row */}
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>BETWEEN THE OWNER AND</td>
                          <td style={{ padding: "3px 6px", textAlign: "center", width: "60%" }}>
                            {isPdfMode ? (
                              <span>{formData.hirer || " "}</span>
                            ) : (
                              <input type="text" value={formData.hirer || ""}
                                onChange={(e) => setFormData({ ...formData, hirer: e.target.value })}
                                placeholder="Enter hirer name"
                                style={{ width: "100%", border: "none", outline: "none", background: "transparent", textAlign: "center", fontSize: "8px" }} />
                            )}
                          </td>
                          <td style={{ padding: "3px 6px", textAlign: "right", width: "20%" }}>AS HIRER ("AGREEMENT")</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* SIGNATURE OF HIRER - body text */}
                  <div style={{ border: "1px solid #9ca3af", margin: "6px", marginTop: "4px" }}>
                    <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0", borderBottom: "1px solid #9ca3af" }}>
                      SIGNATURE OF HIRER
                    </div>
                    <div style={{ padding: "4px 6px", borderBottom: "1px solid #9ca3af", lineHeight: "1.5", textAlign: "justify" }}>
                      <p style={{ marginBottom: "3px" }}>The undersigned hereby confirms and certifies that all of the Products identified or referred to in the Agreement has been received in good condition as ordered and has been assembled, installed, tested, etc., as applicable, and is operating in accordance with the Supplier(s) specifications and was and is unconditionally accepted by us.</p>
                      <p style={{ marginBottom: "3px" }}>The undersigned also certifies that it has made or caused to be made all such tests and inspections of the Products as the undersigned deemed necessary to become satisfied with respect to the foregoing and acknowledges that the undersigned is obligated to pay the rentals and other amounts as stipulated in the Agreement without any right of abatement, set-off, defence or counterclaim whatsoever.</p>
                      <p style={{ marginBottom: "3px" }}>The undersigned further acknowledges that the Supplier(s) and the said Products were selected by the undersigned and the undersigned is satisfied with the design, specifications, operating performance, quality, value, merchantability, exchange value and suitability of the Products for the purposes for which the undersigned intends to use it. Without prejudice to the rights, if any, that the undersigned may have against the Supplier(s) or others, the undersigned hereby releases and discharges Owner from any and all actions, causes of action, claims, demands, rights, defences, set-offs, abatements and compensation now or hereafter arising out of or in relation to the Products, including, without limitation, any latent defect therein. Insurance coverage in respect of the Products has been effected in accordance with the terms of the Agreement.</p>
                      <p style={{ marginBottom: "3px" }}>For the avoidance of doubt, any reference/s in the Agreement to 'deemed acceptance' or its equivalent, shall not apply in relation to the Products included in this Certificate of Acceptance and this actual Certificate of Acceptance is required.</p>
                      <p>Capitalised terms used herein and not defined shall have the same meanings as set forth in the Agreement.</p>
                    </div>
                  </div>

                  {/* SIGNATURE OF HIRER - sign box */}
                  <div style={{ border: "1px solid #9ca3af", margin: "6px", marginTop: "4px" }}>
                    <div style={{ background: "#1F4E79", color: "white", fontWeight: "bold", textAlign: "center", padding: "2px 0", borderBottom: "1px solid #9ca3af" }}>
                      SIGNATURE OF HIRER
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid #9ca3af" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%", verticalAlign: "middle" }}>Authorised Signatory</td>
                          <td style={{ padding: "3px 6px", width: "30%", height: "50px", border: "1px solid #d1d5db", background: "white", verticalAlign: "middle" }}>
                            <div style={{ width: "100%", height: "44px", border: "1px dashed #d1d5db", display: "flex", alignItems: "center", justifyContent: "center", color: "#9ca3af", background: "white" }}>
                              {"{{Sig1_es_:signer1:signature}}"}
                            </div>
                          </td>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%", verticalAlign: "middle" }}>Print Name</td>
                          <td style={{ padding: "3px 6px", width: "30%", verticalAlign: "middle" }}>{formData.managerName || " "}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>Position</td>
                          <td style={{ padding: "3px 6px", width: "30%" }}>{formData.position || " "}</td>
                          <td style={{ background: "#f3f4f6", padding: "3px 6px", fontWeight: "600", width: "20%" }}>Date</td>
                          <td style={{ padding: "3px 6px", width: "30%" }}>{formData.date || " "}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                 <div style={{ height:'200px' }} />
              <div className="w-full">
                <p style={{ fontSize: "9px", color: "#9ca3af" }}>
                  HEUD1024 | Page 12
                </p>
              </div>
              </div>

          </div>
        </div>
      </div>
    );
  }
};

export default RentalAgreementForm;